'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Cookies = require('js-cookie');
var SelectBase = require('react-select');
var Creatable = require('react-select/creatable');
var cx = require('classnames');
var reactFontawesome = require('@fortawesome/react-fontawesome');
var styled = require('@emotion/styled');
var Skeleton = require('react-loading-skeleton');
var reactTinyPopover = require('react-tiny-popover');
var linkifyString = require('linkify-string');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Cookies__default = /*#__PURE__*/_interopDefaultLegacy(Cookies);
var SelectBase__default = /*#__PURE__*/_interopDefaultLegacy(SelectBase);
var Creatable__default = /*#__PURE__*/_interopDefaultLegacy(Creatable);
var cx__default = /*#__PURE__*/_interopDefaultLegacy(cx);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var Skeleton__default = /*#__PURE__*/_interopDefaultLegacy(Skeleton);
var linkifyString__default = /*#__PURE__*/_interopDefaultLegacy(linkifyString);

var palette = {
    black: '#000000',
    white: '#FFFFFF',
    red: ['#F9DEDC', '#F0ADA8', '#E77B73', '#DE4A3F', '#C6413E'],
    orange: ['#FFE9D6', '#FFD3AD', '#FFB370', '#FF9231', '#F57200'],
    yellow: ['#F7F4EA', '#FFF1B2', '#FAE27A', '#FFD002', '#F0C300', '#DBB100'],
    green: ['#D9FEFF', '#ABF9F2', '#73E8DE', '#23D5C6', '#0B887E'],
    turquoise: ['#E3F2F2', '#BADEDE', '#9ED0D1', '#4EA4A6', '#22A0AC', '#1C7E87'],
    blue: ['#DCEFF9', '#95CFEE', '#5FB8E7', '#2199D9', '#1870A0'],
    purple: ['#E6E5F0', '#B5B1D3', '#847CB6', '#675EA5', '#514983'],
    pink: ['#FFEFF4', '#FFD0DF', '#F2A6BE', '#EC799D', '#D0577D'],
    brown: ['#9B803D', '#8E652A', '#5B4028', '#473A31', '#2D241D', '#1C1616'],
    neutral: [
        '#F4F5F5',
        '#EAECEC',
        '#DFE2E2',
        '#C9CECF',
        '#A9B1B2',
        '#889496',
        '#697577',
        '#4D5556',
        '#303536',
        '#222222',
    ],
};
var colors = {
    white: palette.white,
    black: palette.black,
    current: 'currentColor',
    transparent: 'transparent',
    neutral: {
        DEFAULT: palette.neutral[4],
        50: palette.neutral[0],
        100: palette.neutral[1],
        200: palette.neutral[2],
        300: palette.neutral[3],
        400: palette.neutral[4],
        500: palette.neutral[5],
        600: palette.neutral[6],
        700: palette.neutral[7],
        800: palette.neutral[8],
        900: palette.neutral[9],
    },
    red: {
        DEFAULT: palette.red[3],
        100: palette.red[0],
        300: palette.red[1],
        500: palette.red[2],
        700: palette.red[3],
        900: palette.red[4],
    },
    orange: {
        DEFAULT: palette.orange[3],
        100: palette.orange[0],
        300: palette.orange[1],
        500: palette.orange[2],
        700: palette.orange[3],
        900: palette.orange[4],
    },
    yellow: {
        DEFAULT: palette.yellow[3],
        50: palette.yellow[0],
        100: palette.yellow[1],
        300: palette.yellow[2],
        500: palette.yellow[3],
        700: palette.yellow[4],
        900: palette.yellow[5],
    },
    green: {
        DEFAULT: palette.green[3],
        100: palette.green[0],
        300: palette.green[1],
        500: palette.green[2],
        700: palette.green[3],
        900: palette.green[4],
    },
    turquoise: {
        DEFAULT: palette.turquoise[4],
        100: palette.turquoise[0],
        300: palette.turquoise[1],
        500: palette.turquoise[2],
        600: palette.turquoise[3],
        700: palette.turquoise[4],
        900: palette.turquoise[5],
    },
    blue: {
        DEFAULT: palette.blue[3],
        100: palette.blue[0],
        300: palette.blue[1],
        500: palette.blue[2],
        700: palette.blue[3],
        900: palette.blue[4],
    },
    purple: {
        DEFAULT: palette.purple[3],
        100: palette.purple[0],
        300: palette.purple[1],
        500: palette.purple[2],
        700: palette.purple[3],
        900: palette.purple[4],
    },
    pink: {
        DEFAULT: palette.pink[3],
        100: palette.pink[0],
        300: palette.pink[1],
        500: palette.pink[2],
        700: palette.pink[3],
        900: palette.pink[4],
    },
    brown: {
        DEFAULT: palette.brown[3],
        50: palette.brown[0],
        100: palette.brown[1],
        300: palette.brown[2],
        500: palette.brown[3],
        700: palette.brown[4],
        900: palette.brown[5],
    },
};

var typography = {
    standard: 'Lato',
};

var theme = {
    colors: colors,
    extend: {
        screens: {
            xxs: '320px',
            xs: '425px',
            // Widget mobile breakpoint
            wm: '500px',
        },
        fontSize: {
            xxs: [
                '.5rem',
                {
                    lineHeight: '0.75rem',
                },
            ],
        },
        fontFamily: {
            sans: [typography.standard, 'sans-serif'],
            circular: ['Circular Std', 'Arial', 'san-serif'],
        },
        boxShadow: {
            top: '0 -4px 4px 0 rgba(166, 166, 166, 0.13)',
            around: '0 1px 10px 0 rgba(0, 0, 0, 0.1)',
        },
        zIndex: {
            '99': 99,
        },
        spacing: {
            '30': '7.5rem',
            '37': '9.375rem',
        },
        animation: {
            'fade-in': 'fade-in .5s linear forwards',
            'fade-out': 'fade-out .5s linear forwards',
            'fade-in-down': 'fade-in-down .5s linear 1',
            'fade-in-up': 'fade-in-up .5s linear 1',
            'fade-in-left': 'fade-in-left .5s linear 1',
            'fade-in-right': 'fade-in-right .5s linear 1',
            'rotate-360': 'rotate-360 2s linear infinite',
        },
        keyframes: {
            'rotate-360': {
                '0%': { transform: 'rotate(0deg)' },
                '100%': { transform: 'rotate(360deg)' },
            },
            'fade-in': {
                '0%': { opacity: '0' },
                '100%': { opacity: '1' },
            },
            'fade-out': {
                '0%': { opacity: '1' },
                '100%': { opacity: '0' },
            },
            'fade-in-down': {
                '0%': { opacity: '0', transform: 'translateY(-20px)' },
                '100%': { opacity: '1', transform: 'translateY(0)' },
            },
            'fade-in-up': {
                '0%': { opacity: '0', transform: 'translateY(20px)' },
                '100%': { opacity: '1', transform: 'translateY(0)' },
            },
            'fade-in-left': {
                '0%': { opacity: '0', transform: 'translateX(-20px)' },
                '100%': { opacity: '1', transform: 'translateX(0)' },
            },
            'fade-in-right': {
                '0%': { opacity: '0', transform: 'translateX(20px)' },
                '100%': { opacity: '1', transform: 'translateX(0)' },
            },
        },
    },
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function () {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];

      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;

        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };

        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;

        case 7:
          op = _.ops.pop();

          _.trys.pop();

          continue;

        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }

          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }

          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }

          if (t && _.label < t[2]) {
            _.label = t[2];

            _.ops.push(op);

            break;
          }

          if (t[2]) _.ops.pop();

          _.trys.pop();

          continue;
      }

      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
}

var _a, _b;
exports.ButtonVariant = void 0;
(function (ButtonVariant) {
    ButtonVariant["Default"] = "default";
    ButtonVariant["Primary"] = "primary";
    ButtonVariant["Secondary"] = "secondary";
    ButtonVariant["Danger"] = "danger";
    ButtonVariant["Info"] = "info";
    ButtonVariant["Disabled"] = "disabled";
    ButtonVariant["Icon"] = "icon";
})(exports.ButtonVariant || (exports.ButtonVariant = {}));
exports.ButtonSize = void 0;
(function (ButtonSize) {
    ButtonSize["Small"] = "sm";
    ButtonSize["Medium"] = "md";
    ButtonSize["Large"] = "lg";
    ButtonSize["ExtraLarge"] = "xl";
})(exports.ButtonSize || (exports.ButtonSize = {}));
var sizeClasses = (_a = {
        DEFAULT: 'font-bold rounded-md border'
    },
    _a[exports.ButtonSize.Small] = 'py-2 px-3 text-xs',
    _a[exports.ButtonSize.Medium] = 'py-2 px-3 text-sm',
    _a[exports.ButtonSize.Large] = 'py-3 px-4 text-sm',
    _a[exports.ButtonSize.ExtraLarge] = 'py-3 px-4 text-lg',
    _a);
var variantClasses = (_b = {},
    _b[exports.ButtonVariant.Danger] = 'bg-pink-900 border-solid border-pink-900 text-white hover:bg-red-900 hover:border-red-900',
    _b[exports.ButtonVariant.Default] = 'bg-turquoise border-solid border-turquoise text-white hover:bg-turquoise-900 hover:border-turquoise-900',
    _b[exports.ButtonVariant.Disabled] = 'bg-neutral-200 border-solid border-neutral-200 text-neutral-400 hover:bg-neutral-300 hover:border-neutral-300 cursor-not-allowed',
    _b[exports.ButtonVariant.Primary] = 'bg-yellow border-solid text-brown hover:bg-yellow-900 border-yellow hover:border-yellow-900',
    _b[exports.ButtonVariant.Secondary] = 'bg-white text-turquoise border-solid border-neutral-300 hover:bg-turquoise-100',
    _b[exports.ButtonVariant.Info] = 'bg-neutral-200 text-brown-700 hover:bg-neutral-300 border-solid border-neutral-200 hover:border-neutral-300',
    _b[exports.ButtonVariant.Icon] = 'bg-transparent text-neutral-400 border-none outline-none hover:text-turquoise',
    _b);
function Button(_a) {
    var _b;
    var children = _a.children, variantProp = _a.variant, sizeProp = _a.size, props = __rest(_a, ["children", "variant", "size"]);
    var variant = React.useMemo(function () {
        if (props.disabled) {
            return exports.ButtonVariant.Disabled;
        }
        if (variantProp != null) {
            return variantProp;
        }
        if (props.primary) {
            return exports.ButtonVariant.Primary;
        }
        if (props.secondary) {
            return exports.ButtonVariant.Secondary;
        }
        if (props.info) {
            return exports.ButtonVariant.Info;
        }
        if (props.danger) {
            return exports.ButtonVariant.Danger;
        }
        return exports.ButtonVariant.Default;
    }, [props]);
    var size = React.useMemo(function () {
        if (sizeProp != null) {
            return sizeProp;
        }
        if (props.sm || props.small) {
            return exports.ButtonSize.Small;
        }
        if (props.md || props.medium) {
            return exports.ButtonSize.Medium;
        }
        if (props.lg || props.large) {
            return exports.ButtonSize.Large;
        }
        if (props.xl || props.extraLarge) {
            return exports.ButtonSize.ExtraLarge;
        }
        return exports.ButtonSize.Medium;
    }, [props]);
    var className = React.useMemo(function () {
        return [
            sizeClasses.DEFAULT,
            sizeClasses[size],
            variantClasses[variant],
        ].join(' ');
    }, [size, variant]);
    return (React__default["default"].createElement("button", __assign({}, props, { className: "".concat((_b = props.className) !== null && _b !== void 0 ? _b : '', " ").concat(className) }), children));
}

var Image = function (_a) {
    var className = _a.className, src = _a.src;
    return (React__default["default"].createElement("div", { className: className },
        React__default["default"].createElement("img", { className: 'overflow-hidden absolute bottom-0 left-0 h-16 md:h-40', src: src })));
};
function setCookie(_a) {
    var _b;
    var cookieName = _a.cookieName, cookieValue = _a.cookieValue, cookieLifetime = _a.cookieLifetime, cookieDomain = _a.cookieDomain, sessionSecure = _a.sessionSecure;
    Cookies__default["default"].set(cookieName, cookieValue, {
        expires: cookieLifetime,
        domain: cookieDomain,
        path: '/',
        secure: (_b = !!sessionSecure) !== null && _b !== void 0 ? _b : undefined,
    });
}
function CookieDialog(_a) {
    var config = _a.config, _b = _a.imageSrc, imageSrc = _b === void 0 ? 'https://dehjrbasx23dy.cloudfront.net/assets/images/bear-with-cookie.png' : _b, _c = _a.privacyPolicy, privacyPolicy = _c === void 0 ? 'https://www.bonjoro.com/privacy-policy' : _c;
    var _d = React.useState(false), hasCookie = _d[0], setHasCookie = _d[1];
    var container = 'z-99 fixed bottom-0 left-0 w-full bg-white text-center text-turquoise-700 shadow-top', section = 'max-w-screen-lg block md:flex justify-between m-auto', image = 'relative overflow-visible h-10 w-16 md:h-30 md:w-37', header = 'flex flex-row justify-center', desktop = 'hidden md:block', mobile = 'inline-block md:hidden', title = 'text-base font-bold text-neutral-700 mt-5 mb-2.5', message = 'text-neutral-500 text-sm text-center mt-3 mr-px mb-1 ml-0', policy = 'text-neutral-500 text-xs text-center mx-0 mt-1 mb-3', link = 'text-turquoise-700 font-bold', button = 'w-32 mt-2.5 mb-5 md:my-auto md:mx-1';
    React.useEffect(function () {
        var cookieExist = !!Cookies__default["default"].get(config.cookieName);
        setHasCookie(cookieExist);
    }, [config.cookieName]);
    var handleOnClickAgree = function () {
        setCookie(config);
        setHasCookie(true);
    };
    return !hasCookie ? (React__default["default"].createElement("div", { className: container },
        React__default["default"].createElement("div", { className: section },
            React__default["default"].createElement(Image, { className: "".concat(image, " ").concat(desktop), src: imageSrc }),
            React__default["default"].createElement("div", null,
                React__default["default"].createElement("div", { className: header },
                    React__default["default"].createElement(Image, { className: "".concat(image, " ").concat(mobile), src: imageSrc }),
                    React__default["default"].createElement("h3", { className: title }, "Want a cookie?")),
                React__default["default"].createElement("p", { className: message }, "Taking one of our delicious cookies helps us improve your site experience."),
                React__default["default"].createElement("p", { className: policy },
                    "Click",
                    ' ',
                    React__default["default"].createElement("a", { className: link, href: privacyPolicy }, "here"),
                    ' ',
                    "to read our cookie policy.")),
            React__default["default"].createElement(Button, { className: button, onClick: handleOnClickAgree }, "Accept")))) : null;
}

function Control(props) {
    var children = props.children, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps;
    var className = [
        props.className,
        'relative box-border',
        'flex items-center justify-between flex-wrap',
        'bg-white',
        'text-sm font-normal',
        'border border-solid rounded-md hover:border-turquoise-500',
        'shadow-none',
    ].join(' ');
    return (React__default["default"].createElement("div", __assign({ ref: innerRef, className: cx__default["default"](className, {
            'text-turquoise-700 border-turquoise-500': isFocused,
            'text-neutral-400 border-neutral-400': !isFocused,
        }) }, innerProps), children));
}

function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    var className = 'option block w-full box-border px-3 py-2';
    return (React__default["default"].createElement("div", __assign({ ref: innerRef, className: cx__default["default"](className, {
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected bg-turquoise-700 text-white': isSelected,
            'bg-turquoise-100': isFocused && !isSelected,
        }) }, innerProps), children));
}

function DropdownIndicator(props) {
    var menuIsOpen = props.selectProps.menuIsOpen;
    return (React__default["default"].createElement(SelectBase.components.DropdownIndicator, __assign({}, props),
        React__default["default"].createElement(SelectBase.components.DownChevron, { className: cx__default["default"]('transition-transform transform', {
                'rotate-180': menuIsOpen,
            }) })));
}

function Select(_a) {
    var _b = _a.createable, createable = _b === void 0 ? false : _b, _c = _a.clearable, clearable = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.loading, loading = _e === void 0 ? false : _e, _f = _a.multi, multi = _f === void 0 ? false : _f, _g = _a.rtl, rtl = _g === void 0 ? false : _g, _h = _a.searchable, searchable = _h === void 0 ? false : _h, _j = _a.relativeMenu, relativeMenu = _j === void 0 ? false : _j, _k = _a.required, required = _k === void 0 ? false : _k, controlClassName = _a.controlClassName, dropdownIndicatorClassName = _a.dropdownIndicatorClassName, props = __rest(_a, ["createable", "clearable", "disabled", "loading", "multi", "rtl", "searchable", "relativeMenu", "required", "controlClassName", "dropdownIndicatorClassName"]);
    var SelectComponent = createable ? Creatable__default["default"] : SelectBase__default["default"];
    return (React__default["default"].createElement(SelectComponent, __assign({ isClearable: clearable, isDisabled: disabled, isLoading: loading, isMulti: multi, isRtl: rtl, isSearchable: searchable || createable }, props, { components: __assign({ Control: function (controlProps) { return (React__default["default"].createElement(Control, __assign({}, controlProps, { className: controlClassName }))); }, Option: Option, DropdownIndicator: function (dropdownIndicatorProps) { return (React__default["default"].createElement(DropdownIndicator, __assign({}, dropdownIndicatorProps, { className: dropdownIndicatorClassName }))); }, Input: function (inputProps) { return (React__default["default"].createElement(SelectBase.components.Input, __assign({ required: required }, inputProps))); } }, props.components), styles: __assign({ menu: function (base) { return (__assign(__assign({}, base), { position: relativeMenu ? 'relative' : 'absolute' })); } }, props.styles) })));
}
var components = __assign(__assign({}, SelectBase.components), { Control: Control, DropdownIndicator: DropdownIndicator, Option: Option });

var PanelContext = React.createContext({
    disabled: false,
    active: false,
});

var arrow = 'https://cdn.bonjoro.com/assets/bonjoro-ui-components/arrow.svg';
function RightIcon(_a) {
    var active = _a.active;
    return (React__default["default"].createElement("img", { className: cx__default["default"]('transition-transform', {
            'filter invert transform -rotate-90 opacity-30': !active,
        }), src: arrow }));
}

function PanelGroup(_a) {
    var className = _a.className, children = _a.children, props = __rest(_a, ["className", "children"]);
    return (React__default["default"].createElement("div", __assign({ className: cx__default["default"](className, 'py-2 px-3 overflow-y-auto', 'scrollbar-thin scrollbar-track-neutral-200 scrollbar-track-rounded-full', 'scrollbar-thumb-neutral-400 scrollbar-thumb-rounded-full') }, props), children));
}

var Overflow;
(function (Overflow) {
    Overflow["Auto"] = "hidden auto";
    Overflow["Hidden"] = "hidden";
    Overflow["Visible"] = "visible";
})(Overflow || (Overflow = {}));
function Panel(_a) {
    var panelNumber = _a.panelNumber, title = _a.title, children = _a.children, _b = _a.active, active = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, onClick = _a.onClick, rightIcon = _a.rightIcon, _d = _a.overflowVisible, overflowVisible = _d === void 0 ? false : _d, activePanelHeight = _a.activePanelHeight, _e = _a.hidePanelNumber, hidePanelNumber = _e === void 0 ? false : _e, _f = _a.hideRightIcon, hideRightIcon = _f === void 0 ? false : _f;
    var _g = React.useState(active ? activePanelHeight : 0), height = _g[0], setHeight = _g[1];
    var _h = React.useState(active && activePanelHeight ? Overflow.Auto : Overflow.Hidden), overflow = _h[0], setOverflow = _h[1];
    var parentRef = React.useRef(null);
    var childRef = React.useRef(null);
    React.useEffect(function () {
        if (!height || !active || !childRef.current)
            return undefined;
        var resizeObserver = new ResizeObserver(function (el) {
            var newHeight = !activePanelHeight
                ? el[0].contentRect.height
                : Math.min(activePanelHeight, el[0].contentRect.height);
            setHeight(newHeight);
        });
        resizeObserver.observe(childRef.current);
        return function () {
            resizeObserver.disconnect();
        };
    }, [height, activePanelHeight, active]);
    React.useEffect(function () {
        var _a;
        if (active) {
            var childRefHeight = (_a = childRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height;
            var newHeight = !activePanelHeight
                ? childRefHeight
                : Math.min(activePanelHeight, childRefHeight);
            setHeight(newHeight);
        }
        else {
            setHeight(0);
        }
    }, [active]);
    React.useEffect(function () {
        if (!parentRef.current)
            return;
        parentRef.current.addEventListener('transitionstart', handleTransitionStart);
    }, []);
    var context = React.useMemo(function () { return ({
        disabled: disabled,
        active: active,
    }); }, [disabled, active]);
    var handleClick = function (event) {
        if (disabled || active) {
            return;
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    };
    var handleTransitionStart = function (param) {
        if (param.target !== parentRef.current)
            return;
        setOverflow(Overflow.Hidden);
    };
    var handleTransitionEnd = function () {
        if (!active)
            return;
        if (overflowVisible) {
            setOverflow(Overflow.Visible);
        }
        else if (activePanelHeight) {
            setOverflow(Overflow.Auto);
        }
    };
    return (React__default["default"].createElement(PanelContext.Provider, { value: context },
        React__default["default"].createElement("div", { className: cx__default["default"]('bg-white w-auto border-2 border-solid rounded-md mb-6 last:mb-0 shadow-around', {
                'border-turquoise-700': active,
                'border-transparent': !active,
            }), role: !disabled && !active ? 'button' : '', onClick: handleClick },
            React__default["default"].createElement("div", { className: cx__default["default"]('flex items-center gap-x-5 p-5', {
                    'bg-turquoise-700': active,
                    'bg-transparent': !active,
                }) },
                !hidePanelNumber &&
                    React__default["default"].createElement("span", { className: 'text-sm text-turquoise-700 bg-white border border-solid border-turquoise-700 rounded-full h-5 w-5 flex items-center justify-center' }, panelNumber),
                React__default["default"].createElement("span", { className: cx__default["default"]('text-sm', {
                        'text-white': active,
                    }) }, title),
                !hideRightIcon &&
                    React__default["default"].createElement("div", { className: 'ml-auto' }, rightIcon !== null && rightIcon !== void 0 ? rightIcon : React__default["default"].createElement(RightIcon, { active: active }))),
            React__default["default"].createElement("div", { ref: parentRef, className: cx__default["default"]('transition-all duration-300', 'scrollbar-thin scrollbar-track-neutral-200', 'scrollbar-thumb-neutral-400 scrollbar-thumb-rounded-full'), style: { height: height, overflow: overflow }, onTransitionEnd: handleTransitionEnd },
                React__default["default"].createElement("div", { ref: childRef },
                    React__default["default"].createElement("div", { className: 'p-5' }, children))))));
}

var defaultClassName = [
    'text-sm w-full p-3',
    'border border-neutral-300 rounded-md',
    'focus:border-turquoise-700 hover:border-turquoise-700',
    'outline-none resize-none',
].join(' ');
function TextArea(_a) {
    var _b;
    var label = _a.label, _c = _a.value, value = _c === void 0 ? '' : _c, placeholder = _a.placeholder, _d = _a.rows, rows = _d === void 0 ? 1 : _d, maxHeight = _a.maxHeight, inputRef = _a.inputRef, className = _a.className, style = _a.style, props = __rest(_a, ["label", "value", "placeholder", "rows", "maxHeight", "inputRef", "className", "style"]);
    var textAreaRef = inputRef !== null && inputRef !== void 0 ? inputRef : React.useRef(null);
    var _e = React.useState(value), text = _e[0], setText = _e[1];
    var _f = React.useState('auto'), textAreaHeight = _f[0], setTextAreaHeight = _f[1];
    React.useEffect(function () { return setTextAreaHeight('auto'); }, [rows]);
    React.useEffect(function () {
        var scrollHeight = textAreaRef.current.scrollHeight;
        if (maxHeight && maxHeight <= scrollHeight) {
            setTextAreaHeight("".concat(maxHeight, "px"));
            return;
        }
        var newHeight = !text && !placeholder ? 'auto' : "".concat(scrollHeight, "px");
        setTextAreaHeight(newHeight);
    }, [text, placeholder, maxHeight]);
    React.useEffect(function () { return setText(value); }, [value]);
    var onChangeHandler = function (event) {
        var _a;
        setTextAreaHeight('auto');
        setText(event.target.value);
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, event);
    };
    var isScrollbarVisible = text && maxHeight && "".concat(maxHeight, "px") === textAreaHeight;
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        label,
        React__default["default"].createElement("textarea", __assign({ className: cx__default["default"](defaultClassName, className, {
                'overflow-y-auto': isScrollbarVisible,
                'scrollbar-thin scrollbar-track-neutral-200': isScrollbarVisible,
                'scrollbar-thumb-neutral-400 scrollbar-thumb-rounded-full': isScrollbarVisible,
                'overflow-hidden': !isScrollbarVisible,
            }) }, props, { value: text, placeholder: placeholder, ref: textAreaRef, rows: rows, style: {
                height: (_b = style === null || style === void 0 ? void 0 : style.height) !== null && _b !== void 0 ? _b : textAreaHeight,
            }, onChange: onChangeHandler }))));
}

var faArrowRight={prefix:'fas',iconName:'arrow-right',icon:[448,512,[],"f061","M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"]};var faChevronDown={prefix:'fas',iconName:'chevron-down',icon:[448,512,[],"f078","M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"]};var faPaperPlane={prefix:'fas',iconName:'paper-plane',icon:[512,512,[],"f1d8","M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"]};var faPause={prefix:'fas',iconName:'pause',icon:[448,512,[],"f04c","M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"]};var faPlay={prefix:'fas',iconName:'play',icon:[448,512,[],"f04b","M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"]};var faPlus={prefix:'fas',iconName:'plus',icon:[448,512,[],"f067","M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"]};var faTimes={prefix:'fas',iconName:'times',icon:[352,512,[],"f00d","M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"]};var faTrash={prefix:'fas',iconName:'trash',icon:[448,512,[],"f1f8","M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"]};

function Question(_a) {
    var _b = _a.number, number = _b === void 0 ? 1 : _b, _c = _a.value, value = _c === void 0 ? '' : _c, placeholder = _a.placeholder, onUpdate = _a.onUpdate, onDelete = _a.onDelete, onFocus = _a.onFocus;
    var index = React.useMemo(function () { return number - 1; }, [number]);
    var handleOnChange = function (event) {
        return onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate({
            index: index,
            value: event.target.value,
        });
    };
    return (React__default["default"].createElement(TextArea, { className: 'mb-3', label: React__default["default"].createElement("div", { className: 'flex justify-between items-center mb-3' },
            React__default["default"].createElement("p", { className: 'text-sm text-neutral-600 font-bold' },
                "Question ",
                number),
            number > 1 && (React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, { role: 'button', className: 'text-sm text-neutral-600 hover:text-pink-700', icon: faTrash, onClick: function () { return onDelete === null || onDelete === void 0 ? void 0 : onDelete(index); } }))), placeholder: placeholder, value: value, onChange: handleOnChange, onFocus: function () { return onFocus === null || onFocus === void 0 ? void 0 : onFocus(index); } }));
}

function Questionnaire(_a) {
    var data = _a.data, maxQuestions = _a.maxQuestions, onAdd = _a.onAdd, onUpdate = _a.onUpdate, onDelete = _a.onDelete, onFocus = _a.onFocus;
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        data.map(function (question, index) { return (React__default["default"].createElement(Question, __assign({ key: index, number: index + 1, onUpdate: onUpdate, onDelete: onDelete, onFocus: onFocus }, question))); }),
        data.length < maxQuestions && (React__default["default"].createElement(Button, { variant: 'secondary', className: 'w-full', onClick: onAdd },
            React__default["default"].createElement("div", { className: 'flex justify-center items-center gap-x-3' },
                React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, { className: 'text-2xl text-turquoise-700', icon: faPlus }),
                "Add a question")))));
}

var CheckboxContainer = styled__default["default"].label(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  &:hover input ~ span {\n    border: 1px ", " solid;\n  }\n"], ["\n  &:hover input ~ span {\n    border: 1px ", " solid;\n  }\n"])), colors.turquoise[500]);
var CheckboxInput = styled__default["default"].input(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  &:checked ~ span {\n    border: 1px ", " solid;\n  }\n\n  &:checked ~ span:after {\n    display: flex;\n  }\n"], ["\n  &:checked ~ span {\n    border: 1px ", " solid;\n  }\n\n  &:checked ~ span:after {\n    display: flex;\n  }\n"])), colors.turquoise[500]);
var Checkmark = styled__default["default"].span(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  &:after {\n    content: '';\n    display: none;\n    width: 70%;\n    height: 70%;\n    background: ", ";\n    border-radius: 3px;\n    margin: 15%;\n  }\n"], ["\n  &:after {\n    content: '';\n    display: none;\n    width: 70%;\n    height: 70%;\n    background: ", ";\n    border-radius: 3px;\n    margin: 15%;\n  }\n"])), colors.turquoise[700]);
function Checkbox(_a) {
    var name = _a.name, checked = _a.checked, _b = _a.height, height = _b === void 0 ? 20 : _b, _c = _a.width, width = _c === void 0 ? 20 : _c, onChange = _a.onChange, label = _a.label, className = _a.className, disabled = _a.disabled, props = __rest(_a, ["name", "checked", "height", "width", "onChange", "label", "className", "disabled"]);
    return (React__default["default"].createElement(CheckboxContainer, { className: cx__default["default"]('flex relative mb-0 w-max', className, {
            'cursor-pointer': !disabled,
            'cursor-not-allowed': disabled,
        }) },
        React__default["default"].createElement(CheckboxInput, __assign({ className: 'absolute h-0 w-0 opacity-0', type: 'checkbox', name: name, onChange: onChange, checked: checked, disabled: disabled }, props)),
        React__default["default"].createElement(Checkmark, { className: 'border border-solid border-neutral-300 rounded', style: { width: width, height: height } }),
        label && (React__default["default"].createElement("div", { className: 'flex self-center items-center text-sm text-neutral-600 font-medium ml-3 select-none' }, label))));
}
var templateObject_1$5, templateObject_2$1, templateObject_3$1;

function Tab(props) {
    return React__default["default"].createElement("div", null);
}

var ulClassName = [
    'list-none p-0',
    'flex flex-wrap',
    'border-solid border-0 border-b-2 border-neutral-200 mb-0',
].join(' ');
var liClassName = ['flex-initial', 'rounded-t'].join(' ');
var liButtonClassName = [
    'text-sm font-semibold text-neutral-900',
    'items-center justify-center py-3 px-4',
    'hover:bg-turquoise-100 bg-transparent border-0',
    'disabled:opacity-50',
].join(' ');
function Tabs(_a) {
    var id = _a.id, _b = _a.active, active = _b === void 0 ? 0 : _b, className = _a.className, children = _a.children, toolbar = _a.toolbar, setActive = _a.setActive, tabContentClassName = _a.tabContentClassName, tabPanelClassName = _a.tabPanelClassName;
    var handleTabClick = function (index) {
        setActive === null || setActive === void 0 ? void 0 : setActive(index);
    };
    var tabParts = React.useMemo(function () {
        var tabList = [];
        var tabPanel = [];
        children === null || children === void 0 ? void 0 : children.forEach(function (child, index) {
            var _a;
            // Do not render any components aside from Tab
            if (!child || !(((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.name) == Tab.name)) {
                return;
            }
            var activeTab = index == active;
            var _b = child.props, disabled = _b.disabled, children = _b.children;
            tabList.push(React__default["default"].createElement("li", { role: 'presentation', key: index, className: cx__default["default"](liClassName, {
                    'bg-turquoise-100 active': activeTab,
                }), onClick: function () { return handleTabClick(index); } },
                React__default["default"].createElement("button", { id: child.props.id, role: 'tab', className: liButtonClassName, disabled: disabled }, child.props.title)));
            tabPanel.push(React__default["default"].createElement("div", { role: 'tabpanel', key: index, className: cx__default["default"]('absolute tab-panel p-2 w-full transition-opacity', {
                    'hidden z-0': !activeTab,
                    'z-10': activeTab,
                }, tabPanelClassName) }, children));
        });
        return {
            tabList: tabList,
            tabPanel: tabPanel,
        };
    }, [active, children]);
    return (React__default["default"].createElement("div", { id: id, className: className },
        React__default["default"].createElement("div", { className: 'mb-2' },
            React__default["default"].createElement("ul", { role: 'tablist', className: ulClassName }, tabParts.tabList),
            toolbar && React__default["default"].createElement("div", { className: 'w-full' }, toolbar)),
        React__default["default"].createElement("div", { className: cx__default["default"]('tab-content relative', tabContentClassName) }, tabParts.tabPanel),
        children));
}

/**
 * Calls the full screen event depending on which event is available.
 * This varies depending on the current browser.
 * @param videoElement
 * @returns void
 */
function openFullScreen(videoElement) {
    /* eslint-disable @typescript-eslint/unbound-method */
    var fullScreenEvent = videoElement.requestFullscreen ||
        videoElement.webkitRequestFullscreen ||
        videoElement.msRequestFullscreen ||
        videoElement.mozRequestFullScreen;
    if (typeof fullScreenEvent !== 'undefined') {
        // eslint-disable-next-line
        fullScreenEvent.call(videoElement);
    }
    else {
        throw new Error('fullscreenElement is not supported by this browser');
    }
    /* eslint-enable @typescript-eslint/unbound-method */
}
/**
 * Checks if the provided hex string is a light color
 * useful for checking if a text on a given background should use dark or light color
 *
 * https://stackoverflow.com/questions/35969656/how-can-i-generate-the-opposite-color-according-to-current-color
 * @param hex
 * @returns boolean
 */
var isColorLight = function (hex) {
    if (hex.indexOf('#') === 0) {
        hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
        throw new Error('Invalid HEX color.');
    }
    var r = parseInt(hex.slice(0, 2), 16), g = parseInt(hex.slice(2, 4), 16), b = parseInt(hex.slice(4, 6), 16);
    // https://stackoverflow.com/a/3943023/112731
    return r * 0.299 + g * 0.587 + b * 0.114 > 186;
};
/**
 * Converts the collection to a consecutive partitioned collection base on the
 * predicate
 *
 * @param collection
 * @param predicate
 * @returns partitions
 */
function consecutivePartition(collection, predicate) {
    if (collection.length === 0) {
        return [];
    }
    var partitions = [];
    var current = [collection[0]];
    for (var i = 1; i < collection.length; i++) {
        if (predicate(current[0], collection[i])) {
            current.push(collection[i]);
        }
        else {
            partitions.push(current);
            current = [collection[i]];
        }
    }
    partitions.push(current);
    return partitions;
}
// eslint-disable-next-line
function createPlasmicComponent(component, meta) {
    return [component, meta];
}

var muteWhite = 'https://cdn.bonjoro.com/assets/bonjoro-ui-components/mute-white.svg';
function WidgetPreview(_a) {
    var videoUrl = _a.videoUrl, message = _a.message, muteIconBgColor = _a.muteIconBgColor, className = _a.className, messageClassName = _a.messageClassName, videoClassName = _a.videoClassName, onClick = _a.onClick, onClose = _a.onClose, onVideoLoaded = _a.onVideoLoaded, onVideoEnded = _a.onVideoEnded;
    var onCloseClick = function (event) {
        event.stopPropagation();
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    var videoElement = React.useRef(null);
    var onVideoLoadedHandler = function () {
        var _a;
        onVideoLoaded === null || onVideoLoaded === void 0 ? void 0 : onVideoLoaded();
        // eslint-disable-next-line
        if (videoElement.current) {
            void ((_a = videoElement.current) === null || _a === void 0 ? void 0 : _a.play());
            videoElement.current.volume = 0;
        }
    };
    return (React__default["default"].createElement("div", { className: cx__default["default"](className, [
            'h-24 sm:h-36 rounded shadow absolute transition-all',
            'drop-shadow-md cursor-pointer inline-flex',
        ]), onClick: onClick },
        React__default["default"].createElement("div", { className: 'flex relative' },
            React__default["default"].createElement("video", { className: cx__default["default"](videoClassName, [
                    'rounded cursor-pointer object-cover w-24 sm:w-36',
                ]), ref: videoElement, autoPlay: true, muted: true, onLoadedData: onVideoLoadedHandler, onEnded: onVideoEnded, src: videoUrl }),
            React__default["default"].createElement("img", { className: 'absolute h-6 w-6 bottom-2 right-2 p-1 rounded-full', src: muteWhite, style: { backgroundColor: muteIconBgColor } })),
        React__default["default"].createElement("div", { className: 'flex-1 w-48 sm:w-60 flex px-4 py-4 sm:pt-6 sm:pb-5 relative' },
            React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, { className: 'text-xs sm:text-xl text-neutral-300 hover:text-neutral-500 cursor-pointer absolute top-2 right-2', icon: faTimes, onClick: onCloseClick }),
            React__default["default"].createElement("p", { className: cx__default["default"](messageClassName, [
                    'line-clamp-4 text-xs sm:text-base',
                ]) }, message))));
}

function Ping(_a) {
    var _b = _a.color, color = _b === void 0 ? colors.turquoise[700] : _b, _c = _a.animationColor, animationColor = _c === void 0 ? colors.turquoise[300] : _c, _d = _a.showAnimation, showAnimation = _d === void 0 ? true : _d, _e = _a.size, size = _e === void 0 ? 15 : _e, className = _a.className, onClick = _a.onClick;
    return (React__default["default"].createElement("span", { className: cx__default["default"](className, "flex absolute cursor-pointer"), onClick: onClick, style: { width: size, height: size } },
        showAnimation &&
            React__default["default"].createElement("span", { className: "animate-ping absolute inline-flex h-full w-full rounded-full opacity-75", style: { backgroundColor: animationColor } }),
        React__default["default"].createElement("span", { className: "relative inline-flex rounded-full", style: { backgroundColor: color, width: size, height: size } })));
}

function WidgetBubble(_a) {
    var iconImageUrl = _a.iconImageUrl, borderColor = _a.borderColor, _b = _a.borderWidth, borderWidth = _b === void 0 ? 2 : _b, _c = _a.pingColor, pingColor = _c === void 0 ? colors.pink[900] : _c, _d = _a.pingAnimationColor, pingAnimationColor = _d === void 0 ? colors.pink[500] : _d, _e = _a.size, size = _e === void 0 ? 32 : _e, onClick = _a.onClick, _f = _a.showPing, showPing = _f === void 0 ? false : _f, className = _a.className;
    return (React__default["default"].createElement("div", { className: cx__default["default"](className, "rounded-md border-solid cursor-pointer relative inline-flex animate-fade-in-down"), onClick: onClick, style: { borderColor: borderColor, borderWidth: borderWidth } },
        React__default["default"].createElement("img", { className: cx__default["default"]("object-cover rounded"), src: iconImageUrl, style: { height: size, width: size } }),
        showPing &&
            React__default["default"].createElement(Ping, { color: pingColor, animationColor: pingAnimationColor, className: "-top-2 -right-2", onClick: onClick })));
}

function ProfilePanel(_a) {
    var name = _a.name, imageUrl = _a.imageUrl, description = _a.description, className = _a.className, _b = _a.loading, loading = _b === void 0 ? false : _b, reactionComponent = _a.reactionComponent;
    return (React__default["default"].createElement(Skeleton.SkeletonTheme, { baseColor: colors.neutral[50], highlightColor: colors.neutral[200] },
        React__default["default"].createElement("div", { className: cx__default["default"](className, 'w-full bg-black bg-opacity-50 px-2 py-1') },
            React__default["default"].createElement("div", { className: 'w-full flex justify-between' },
                React__default["default"].createElement("div", { className: 'w-full inline-flex gap-x-2 items-center' },
                    React__default["default"].createElement(ProfileImage, { loading: loading, imageUrl: imageUrl }),
                    React__default["default"].createElement("span", { className: cx__default["default"]([
                            'flex flex-col w-3/5 sm:w-2/3 justify-items-end',
                            'text-left text-xs text-white',
                        ], {
                            'gap-y-1': !loading,
                            'gap-y-2': loading,
                        }) },
                        React__default["default"].createElement(ProfileInfo, { loading: loading, name: name, description: description })))),
            React__default["default"].createElement("div", { className: cx__default["default"]('transform absolute  right-2 -translate-y-1/2', {
                    'w-10 h-10 top-[1.35rem]': loading,
                    'top-1/2': !loading,
                }) },
                React__default["default"].createElement(ProfileReaction, { loading: loading, reactionComponent: reactionComponent })))));
}
function ProfileImage(_a) {
    var loading = _a.loading, imageUrl = _a.imageUrl;
    if (loading) {
        return (React__default["default"].createElement(Skeleton__default["default"], { height: '100%', containerClassName: 'rounded h-9 w-10 mb-2' }));
    }
    return (React__default["default"].createElement("img", { className: 'animate-fade-in object-cover rounded h-10 w-10', src: imageUrl }));
}
function ProfileInfo(_a) {
    var loading = _a.loading, name = _a.name, description = _a.description;
    if (loading) {
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement(Skeleton__default["default"], { height: '100%', containerClassName: 'h-3 w-1/2', borderRadius: 0 }),
            React__default["default"].createElement(Skeleton__default["default"], { height: '100%', containerClassName: 'h-3 w-1/3', borderRadius: 0 })));
    }
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("span", { className: 'animate-fade-in flex-1 text-base font-bold truncate' }, name),
        React__default["default"].createElement("span", { className: 'animate-fade-in flex-1 text-xs truncate' }, description)));
}
function ProfileReaction(_a) {
    var loading = _a.loading, reactionComponent = _a.reactionComponent;
    if (loading) {
        return React__default["default"].createElement(Skeleton__default["default"], { circle: true, height: '100%', containerClassName: 'w-10 h-full' });
    }
    return React__default["default"].createElement(React__default["default"].Fragment, null, reactionComponent);
}

function VideoPlayerOverlay(_a) {
    var className = _a.className, onClick = _a.onClick;
    return (React__default["default"].createElement("div", { className: cx__default["default"](className, [
            'fixed inset-0 bg-black bg-opacity-50 overflow-y-auto w-full h-full z-30',
        ]), onClick: onClick }));
}

var volumeIcon = 'https://cdn.bonjoro.com/assets/bonjoro-ui-components/volume-white.svg';
var volumeMuteIcon = 'https://cdn.bonjoro.com/assets/bonjoro-ui-components/volume-mute-white.svg';
var fullScreenIcon = 'https://cdn.bonjoro.com/assets/bonjoro-ui-components/full-screen-white.svg';
var exitFullScreenIcon = 'https://cdn.bonjoro.com/assets/bonjoro-ui-components/exit-full-screen-white.svg';
var newTabIcon$1 = 'https://cdn.bonjoro.com/assets/bonjoro-ui-components/new-tab-white.svg';
var actionIconClass = 'overflow-visible z-10 cursor-pointer select-none';
var NewTabIcon = styled__default["default"].img(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var newTabHoverColor = _a.newTabHoverColor;
    return "\n    &:hover {\n      background-color: ".concat(newTabHoverColor !== null && newTabHoverColor !== void 0 ? newTabHoverColor : 'transparent', ";\n    }\n  ");
});
function VideoControls(_a) {
    var fullScreen = _a.fullScreen, playing = _a.playing, muted = _a.muted, _b = _a.showControls, showControls = _b === void 0 ? true : _b, leftHeaderComponent = _a.leftHeaderComponent, footerComponent = _a.footerComponent, newTabHoverColor = _a.newTabHoverColor, hideClose = _a.hideClose, hideNewTab = _a.hideNewTab, hidePlayPause = _a.hidePlayPause, hideMuteUnmute = _a.hideMuteUnmute, hideFullScreen = _a.hideFullScreen, onPlayPauseClick = _a.onPlayPauseClick, onMuteUnmuteClick = _a.onMuteUnmuteClick, onFullScreenClick = _a.onFullScreenClick, onNewTabClick = _a.onNewTabClick, onCloseClick = _a.onCloseClick;
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        showControls && (React__default["default"].createElement("div", { className: 'absolute flex flex-col w-full top-0', onClick: onPlayPauseClick },
            React__default["default"].createElement("div", { className: 'flex flex-row justify-between' },
                React__default["default"].createElement("div", null, leftHeaderComponent),
                React__default["default"].createElement("div", { className: 'inline-flex' },
                    !hideNewTab && (React__default["default"].createElement(NewTabIcon, { newTabHoverColor: newTabHoverColor, className: cx__default["default"](actionIconClass, 'w-7 h-7 p-1'), src: newTabIcon$1, onClick: function (e) {
                            e.stopPropagation();
                            onNewTabClick === null || onNewTabClick === void 0 ? void 0 : onNewTabClick();
                        }, title: 'Open in a new window' })),
                    !hideClose && (React__default["default"].createElement("div", { className: 'px-1 bg-black bg-opacity-50 h-7 flex items-center' },
                        React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, { className: 'w-5 h-6 text-white cursor-pointer', icon: faTimes, onClick: function (e) {
                                e.stopPropagation();
                                onCloseClick === null || onCloseClick === void 0 ? void 0 : onCloseClick();
                            }, title: 'Close' }))))))),
        React__default["default"].createElement("div", { className: 'absolute flex flex-col w-full bottom-0 z-50' },
            showControls && (React__default["default"].createElement("div", { className: 'flex flex-row justify-between pointer-events-auto z-50', onClick: onPlayPauseClick },
                React__default["default"].createElement("div", { className: 'px-3 py-2' }, !hidePlayPause && (React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, { onClick: onPlayPauseClick, className: 'text-4xl text-white cursor-pointer', icon: playing ? faPause : faPlay, title: 'Play/Pause' }))),
                React__default["default"].createElement("div", { className: 'inline-flex p-3 pt-2 gap-x-4 items-center' },
                    !hideMuteUnmute && (React__default["default"].createElement("img", { className: cx__default["default"](actionIconClass, 'w-5 h-5'), src: (muted ? volumeMuteIcon : volumeIcon), title: 'Mute/Unmute', onClick: function (e) {
                            e.stopPropagation();
                            onMuteUnmuteClick === null || onMuteUnmuteClick === void 0 ? void 0 : onMuteUnmuteClick();
                        } })),
                    !hideFullScreen && (React__default["default"].createElement("img", { className: cx__default["default"](actionIconClass, 'w-5 h-5'), src: (fullScreen ? exitFullScreenIcon : fullScreenIcon), onClick: function (e) {
                            e.stopPropagation();
                            onFullScreenClick === null || onFullScreenClick === void 0 ? void 0 : onFullScreenClick();
                        }, title: 'Full screen' }))))),
            footerComponent)));
}
var templateObject_1$4;

function VideoPlayerComponent(_a) {
    var _b;
    var _c;
    var videoUrl = _a.videoUrl, videoTitle = _a.videoTitle, videoThumbnail = _a.videoThumbnail, containerClassName = _a.containerClassName, videoClassName = _a.videoClassName, _d = _a.showDefaultFullScreen, showDefaultFullScreen = _d === void 0 ? false : _d, _e = _a.showDefaultControls, showDefaultControls = _e === void 0 ? false : _e, _f = _a.autoPlay, autoPlay = _f === void 0 ? true : _f, _g = _a.loop, loop = _g === void 0 ? true : _g, _h = _a.fullScreen, fullScreen = _h === void 0 ? false : _h, children = _a.children, footerComponent = _a.footerComponent, leftHeaderComponent = _a.leftHeaderComponent, _j = _a.preload, preload = _j === void 0 ? 'auto' : _j, _k = _a.playsInline, playsInline = _k === void 0 ? true : _k, hidePlayPause = _a.hidePlayPause, hideMuteUnmute = _a.hideMuteUnmute, hideFullScreen = _a.hideFullScreen, hideClose = _a.hideClose, hideNewTab = _a.hideNewTab, _l = _a.hideLoader, hideLoader = _l === void 0 ? false : _l, newTabHoverColor = _a.newTabHoverColor, onNewTabClick = _a.onNewTabClick, onCloseClick = _a.onCloseClick, onFullScreenClick = _a.onFullScreenClick, onVideoLoaded = _a.onVideoLoaded, videoRef = _a.videoRef, containerRef = _a.containerRef, props = __rest(_a, ["videoUrl", "videoTitle", "videoThumbnail", "containerClassName", "videoClassName", "showDefaultFullScreen", "showDefaultControls", "autoPlay", "loop", "fullScreen", "children", "footerComponent", "leftHeaderComponent", "preload", "playsInline", "hidePlayPause", "hideMuteUnmute", "hideFullScreen", "hideClose", "hideNewTab", "hideLoader", "newTabHoverColor", "onNewTabClick", "onCloseClick", "onFullScreenClick", "onVideoLoaded", "videoRef", "containerRef"]);
    var _m = React.useState(false), activeDefaultFullScreen = _m[0], setActiveDefaultFullScreen = _m[1];
    var _o = React.useState(autoPlay), playing = _o[0], setPlaying = _o[1];
    var _p = React.useState((_c = props.muted) !== null && _c !== void 0 ? _c : autoPlay), muted = _p[0], setMuted = _p[1];
    var _q = React.useState(false), videoLoaded = _q[0], setVideoLoaded = _q[1];
    var videoElement = videoRef !== null && videoRef !== void 0 ? videoRef : React.useRef(null);
    var toggleMute = function () { return setMuted(!muted); };
    var togglePlaying = function () { return setPlaying(!playing); };
    var onVideoLoadedHandler = function () {
        setVideoLoaded(true);
        onVideoLoaded === null || onVideoLoaded === void 0 ? void 0 : onVideoLoaded();
    };
    var onCloseClickHandler = function () {
        setPlaying(false);
        onCloseClick === null || onCloseClick === void 0 ? void 0 : onCloseClick();
    };
    var onVolumeChangeHandler = React.useCallback(function () {
        var _a;
        if (!videoLoaded || !videoElement.current)
            return;
        setMuted((_a = videoElement.current) === null || _a === void 0 ? void 0 : _a.muted);
    }, [videoElement.current]);
    var toggleFullScreen = React.useCallback(function () {
        if (showDefaultFullScreen && (videoElement === null || videoElement === void 0 ? void 0 : videoElement.current)) {
            openFullScreen(videoElement === null || videoElement === void 0 ? void 0 : videoElement.current);
        }
        else {
            onFullScreenClick === null || onFullScreenClick === void 0 ? void 0 : onFullScreenClick();
        }
    }, [showDefaultFullScreen, fullScreen]);
    React.useEffect(function () {
        var _a, _b;
        if (!videoLoaded || !videoElement.current)
            return;
        if (playing) {
            // eslint-disable-next-line
            (_a = videoElement.current) === null || _a === void 0 ? void 0 : _a.play();
        }
        else {
            (_b = videoElement.current) === null || _b === void 0 ? void 0 : _b.pause();
        }
    }, [playing, videoLoaded, videoElement.current]);
    React.useEffect(function () {
        if (!videoElement.current)
            return;
        videoElement.current.onfullscreenchange = function () {
            setActiveDefaultFullScreen(document.fullscreenElement !== null);
        };
        videoElement.current.onwebkitfullscreenchange = function () {
            setActiveDefaultFullScreen(document.webkitFullscreenElement !== null);
        };
        videoElement.current.onmozfullscreenchange = function () {
            setActiveDefaultFullScreen(document.fullscreenElement !== null);
        };
    }, [activeDefaultFullScreen, videoElement.current, document]);
    var activeCustomFullScreen = !activeDefaultFullScreen && fullScreen;
    return (React__default["default"].createElement("div", { className: cx__default["default"](containerClassName, {
            'cursor-pointer inline-flex relative': !fullScreen,
            'fixed transform left-1/2 top-1/2 -translate-x-1/2 ': fullScreen,
            '-translate-y-1/2 translate z-40 w-screen sm:w-auto sm:h-auto flex justify-center': fullScreen,
        }), ref: containerRef, onClick: togglePlaying },
        React__default["default"].createElement("div", { key: videoUrl, className: cx__default["default"]('flex relative w-full', {
                'drop-shadow shadow': activeCustomFullScreen,
            }) },
            !hideLoader && (React__default["default"].createElement("span", { className: cx__default["default"]('absolute w-full h-full flex flex-col bg-neutral-400', {
                    'animate-fade-out': videoLoaded,
                }) })),
            React__default["default"].createElement("video", { id: 'bonjoro-video-player', ref: videoElement, className: cx__default["default"]('cursor-pointer', (_b = {
                        'object-cover': !activeDefaultFullScreen,
                        'h-full w-full': activeCustomFullScreen
                    },
                    _b[videoClassName !== null && videoClassName !== void 0 ? videoClassName : ''] = !fullScreen,
                    _b)), poster: videoThumbnail, title: videoTitle, controls: showDefaultControls, playsInline: playsInline, "webkit-playsinline": playsInline && 'webkit-playsinline', preload: preload, muted: muted, loop: loop, onClick: togglePlaying, onTouchEnd: function (event) {
                    event.preventDefault();
                    togglePlaying();
                }, onTouchMove: function (event) {
                    event.preventDefault();
                }, onPlay: function () {
                    setPlaying(true);
                }, onPause: function () {
                    setPlaying(false);
                }, onLoadedData: onVideoLoadedHandler, onVolumeChange: onVolumeChangeHandler, 
                /**
                 * iOS safari doesn't show the first frame when poster is not provided.
                 * Hacky solution is to use Media fragments, to skip the first millisecond.
                 * see: https://muffinman.io/blog/hack-for-ios-safari-to-display-html-video-thumbnail/
                 */
                src: "".concat(videoUrl, "#t=0.001") }, children),
            !showDefaultControls && (React__default["default"].createElement(VideoControls, { fullScreen: fullScreen, playing: playing, muted: muted, hideClose: hideClose, hideNewTab: hideNewTab, hidePlayPause: hidePlayPause, hideMuteUnmute: hideMuteUnmute, hideFullScreen: hideFullScreen, onPlayPauseClick: togglePlaying, onMuteUnmuteClick: toggleMute, onFullScreenClick: toggleFullScreen, onNewTabClick: onNewTabClick, onCloseClick: onCloseClickHandler, newTabHoverColor: newTabHoverColor, leftHeaderComponent: leftHeaderComponent, footerComponent: footerComponent, showControls: videoLoaded })))));
}

function VideoPlayerContainer(props) {
    var _a = React.useState(false), fullScreen = _a[0], setFullScreen = _a[1];
    var toggleFullScreen = function () {
        var _a;
        (_a = props.onFullScreenClick) === null || _a === void 0 ? void 0 : _a.call(props);
        setFullScreen(!fullScreen);
    };
    var videoPlayerProps = React.useMemo(function () {
        if (!fullScreen)
            return props;
        return __assign(__assign({}, props), { className: 'justify-center', hideClose: true, width: '100%', height: '100%' });
    }, [props, fullScreen]);
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(VideoPlayerComponent, __assign({}, videoPlayerProps, { fullScreen: fullScreen, onFullScreenClick: toggleFullScreen })),
        fullScreen && (React__default["default"].createElement(VideoPlayerOverlay, { className: props === null || props === void 0 ? void 0 : props.overlayClassName, onClick: toggleFullScreen }))));
}

var reactionAnimationImage = 'https://cdn.bonjoro.com/assets/bonjoro-ui-components/reaction-animation.png';
var ReactionIcon = styled__default["default"].button(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  min-width: 45px;\n  box-shadow: 0 4px 6px rgb(50 50 93 / 10%), 0 1px 3px rgb(0 0 0 / 10%);\n  &:active {\n    transform: scale(0.8);\n  }\n"], ["\n  min-width: 45px;\n  box-shadow: 0 4px 6px rgb(50 50 93 / 10%), 0 1px 3px rgb(0 0 0 / 10%);\n  &:active {\n    transform: scale(0.8);\n  }\n"])));
var TooltipTriangle = styled__default["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-left-color: ", ";\n"], ["\n  border-left-color: ", ";\n"])), colors.yellow[700]);
var ReactionAnimation = styled__default["default"].div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background: url(", ") no-repeat 0 0;\n  transition: background-position 1s steps(25);\n  transition-duration: 0s;\n  &.active {\n      left: 50%;\n      transition-duration: 1s;\n      background-position: -2500px 0;\n    }\n  }\n"], ["\n  background: url(", ") no-repeat 0 0;\n  transition: background-position 1s steps(25);\n  transition-duration: 0s;\n  &.active {\n      left: 50%;\n      transition-duration: 1s;\n      background-position: -2500px 0;\n    }\n  }\n"])), reactionAnimationImage);
var emojis = [
    '👏',
    '👍',
    '🔥',
    '😁',
    '🤩',
    '🤗',
    '😸',
    '🤝',
    '✅',
    '👊',
    '👌',
    '🤙',
    '🙏',
    '👀',
    '🐻',
    '⭐',
    '️🥇',
    '🏆',
    '🚀',
    '🎉',
    '💯',
    '🆒',
];
function ReactionButton(_a) {
    var _b;
    var initialCount = _a.initialCount, onClick = _a.onClick, _c = _a.hideCount, hideCount = _c === void 0 ? false : _c, _d = _a.hideTooltip, hideTooltip = _d === void 0 ? false : _d, _e = _a.tooltipText, tooltipText = _e === void 0 ? 'Say thanks' : _e, className = _a.className, _f = _a.tooltipClassName, tooltipClassName = _f === void 0 ? '' : _f, _g = _a.tooltipTriangleClassName, tooltipTriangleClassName = _g === void 0 ? '' : _g, _h = _a.tooltipContainerClassName, tooltipContainerClassName = _h === void 0 ? '' : _h, _j = _a.showAnimationClassName, showAnimationClassName = _j === void 0 ? '' : _j, _k = _a.buttonClassName, buttonClassName = _k === void 0 ? '' : _k, _l = _a.countClassName, countClassName = _l === void 0 ? '' : _l, _m = _a.emojiClassName, emojiClassName = _m === void 0 ? '' : _m;
    var _o = React.useState(initialCount !== null && initialCount !== void 0 ? initialCount : 0), count = _o[0], setCount = _o[1];
    var _p = React.useState(false), showAnimation = _p[0], setShowAnimation = _p[1];
    var emoji = count >= emojis.length ? emojis[count % emojis.length] : emojis[count];
    var toggleAnimation = function () {
        // Reset from the initial frame of animation
        setShowAnimation(false);
        // Show the animation after .05 seconds
        setTimeout(function () {
            setShowAnimation(true);
        }, 50);
    };
    var handleClick = function (evt) {
        evt.stopPropagation();
        var newCount = count + 1;
        setCount(newCount);
        onClick === null || onClick === void 0 ? void 0 : onClick({
            count: newCount,
            emoji: emoji,
        });
        toggleAnimation();
    };
    return (React__default["default"].createElement("div", { className: cx__default["default"](className, [
            'flex flex-row-reverse z-50 pr-25 relative min-w-min',
        ]) },
        React__default["default"].createElement(ReactionAnimation, { className: cx__default["default"]([
                'transform -translate-x-1/2 -translate-y-1/2 absolute left-1/2 top-1/2',
            ], (_b = {},
                _b["h-24 w-24 z-40 active ".concat(showAnimationClassName)] = showAnimation,
                _b['h-0 w-0 z-0'] = !showAnimation,
                _b)) }),
        React__default["default"].createElement(ReactionIcon, { className: cx__default["default"](buttonClassName, [
                'h-11 z-40 p-0 flex flex-row justify-center items-center border-0',
                'outline-0 bg-white bg-opacity-20 rounded-full',
                'transform transition-all hover:scale-125 select-none',
            ]), onClick: handleClick },
            !hideCount && count > 0 && (React__default["default"].createElement("span", { className: "pl-2.5 block text-base font-bold text-white ".concat(countClassName) }, count)),
            React__default["default"].createElement("span", { className: "px-2.5 block text-lg ".concat(emojiClassName) }, emoji)),
        !hideTooltip && count === 0 && (React__default["default"].createElement("div", { className: "my-2 pr-2 h-7 block relative ".concat(tooltipContainerClassName) },
            React__default["default"].createElement("div", { className: cx__default["default"](tooltipClassName, [
                    'h-7 px-2.5 inline-block bg-yellow-700 leading-7',
                    'text-sm font-medium text-black rounded truncate',
                ]) },
                tooltipText,
                React__default["default"].createElement(TooltipTriangle, { className: cx__default["default"](tooltipTriangleClassName, [
                        'border-8 border-solid border-transparent w-0 h-0 absolute',
                        '-right-1.5 top-1.5',
                    ]) }))))));
}
var templateObject_1$3, templateObject_2, templateObject_3;

var newTabIcon = 'https://cdn.bonjoro.com/assets/bonjoro-ui-components/new-tab-white.svg';
var CtaIcon = styled__default["default"].div(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var color = _a.color;
    return "\n    background: ".concat(color, ";\n    mask: url(\"").concat(newTabIcon, "\");\n    mask-size: contain;\n    mask-repeat: no-repeat;\n    mask-position: center;\n  ");
});
function VideoMessage(_a) {
    var message = _a.message, _b = _a.hideCta, hideCta = _b === void 0 ? false : _b, ctaText = _a.ctaText, className = _a.className, _c = _a.ctaColor, ctaColor = _c === void 0 ? colors.black : _c, loading = _a.loading, onCtaClick = _a.onCtaClick, footer = _a.footer, ctaHref = _a.ctaHref;
    var callToAction = React.useMemo(function () {
        var ctaButton = (React__default["default"].createElement("button", { className: cx__default["default"]([
                'inline-flex px-3 py-1.5 items-center gap-x-2 rounded-full',
                'border border-solid bg-white transform transition-all hover:scale-105',
            ]), style: { borderColor: ctaColor, color: ctaColor }, onClick: onCtaClick },
            ctaText,
            React__default["default"].createElement(CtaIcon, { color: ctaColor, className: cx__default["default"]('w-3 h-3 p-1'), title: 'Open on new window' })));
        if (ctaHref) {
            return (React__default["default"].createElement("a", { href: ctaHref, rel: 'noopener noreferer noreferrer', target: '_blank' }, ctaButton));
        }
        return ctaButton;
    }, [ctaColor, onCtaClick, ctaText, ctaHref]);
    var messageComponent = (React__default["default"].createElement("div", { className: 'animate-fade-in' },
        React__default["default"].createElement("div", { className: 'text-neutral-600 font-normal text-sm' }, message),
        React__default["default"].createElement("div", { className: 'justify-start py-2' }, !hideCta && callToAction)));
    var loaderComponent = (React__default["default"].createElement("div", { className: 'mb-10' },
        React__default["default"].createElement(Skeleton.SkeletonTheme, { baseColor: colors.neutral[300], highlightColor: colors.neutral[400], borderRadius: 0 },
            React__default["default"].createElement(Skeleton__default["default"], { className: 'h-2.5', count: 6 }))));
    return (React__default["default"].createElement("div", { className: cx__default["default"](className, 'w-full flex flex-col px-3 py-1.5') },
        !loading ? messageComponent : loaderComponent,
        footer));
}
var templateObject_1$2;

var ScrollDirection;
(function (ScrollDirection) {
    ScrollDirection[ScrollDirection["Up"] = 0] = "Up";
    ScrollDirection[ScrollDirection["Down"] = 1] = "Down";
})(ScrollDirection || (ScrollDirection = {}));
/**
 * This custom hook listens to scroll event on the target element
 * to determine the scroll direction and current scroll position.
 */
function useScrollDirection(target) {
    var _a, _b;
    var _c = React.useState((_b = (_a = target.current) === null || _a === void 0 ? void 0 : _a.scrollTop) !== null && _b !== void 0 ? _b : 0), scrollPosition = _c[0], setScrollPosition = _c[1];
    var _d = React.useState(), scrollDirection = _d[0], setScrollDirection = _d[1];
    var handleScroll = React.useCallback(function () {
        var currentElement = target.current;
        if (currentElement) {
            var scrollTop = currentElement.scrollTop;
            if (scrollTop > scrollPosition) {
                setScrollDirection(ScrollDirection.Down);
            }
            else {
                setScrollDirection(ScrollDirection.Up);
            }
            setScrollPosition(scrollTop);
        }
    }, [target, scrollPosition]);
    React.useEffect(function () {
        var currentElement = target.current;
        if (currentElement) {
            currentElement.addEventListener('scroll', handleScroll);
        }
        return function () {
            currentElement === null || currentElement === void 0 ? void 0 : currentElement.removeEventListener('scroll', handleScroll);
        };
    }, [target, handleScroll]);
    return {
        scrollPosition: scrollPosition,
        scrollDirection: scrollDirection,
    };
}

function SentWithBonjoroBadge(_a) {
    var iconUrl = _a.iconUrl, _b = _a.textColor, textColor = _b === void 0 ? colors.white : _b, _c = _a.arrowColor, arrowColor = _c === void 0 ? colors.yellow[900] : _c, className = _a.className, onClick = _a.onClick;
    var onClickHandler = function (event) {
        event.stopPropagation();
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    return (React__default["default"].createElement("div", { className: cx__default["default"](className, [
            'inline-flex cursor-pointer px-2.5 py-1 gap-1',
        ]), onClick: onClickHandler },
        React__default["default"].createElement("div", { className: 'flex items-center' },
            React__default["default"].createElement("img", { src: iconUrl, alt: 'Bonjoro Logo', className: 'w-6 h-6' })),
        React__default["default"].createElement("div", { className: 'flex-1 flex flex-col justify-center font-circular', style: { color: textColor } },
            React__default["default"].createElement("div", { className: 'h-3 text-xxs' }, "Sent with"),
            React__default["default"].createElement("div", { className: 'h-6 text-base font-bold tracking-wide -mt-1' }, "bonjoro")),
        React__default["default"].createElement("div", { className: 'flex-1 flex items-center ml-1.5' },
            React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, { className: 'text-xl', icon: faArrowRight, style: { color: arrowColor } }))));
}

EmojiPicker.defaultProps = {
    theme: 'light',
    emoji: 'slightly_smiling_face',
    title: 'Choose your emoji',
    size: 16,
    data: function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch('https://cdn.jsdelivr.net/npm/@emoji-mart/data/sets/14/apple.json')];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.json()];
            }
        });
    }); },
};
function EmojiPicker(props) {
    var ref = React.useRef(null);
    React.useEffect(function () {
        void Promise.resolve().then(function () { return /*#__PURE__*/_interopNamespace(require('emoji-mart')); }).then(function (emojiMart) {
            new emojiMart.Picker(__assign(__assign({}, props), { ref: ref }));
        });
    }, []);
    return React__default["default"].createElement("div", { ref: ref });
}

/*!
 * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */
var faLaugh = {
  prefix: 'far',
  iconName: 'laugh',
  icon: [496, 512, [], "f599", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM328 224c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm-160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm194.4 64H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"]
};

function EmojiSelector(_a) {
    var _b = _a.closeOnSelect, closeOnSelect = _b === void 0 ? false : _b, iconClassName = _a.iconClassName, iconContainerClassName = _a.iconContainerClassName, popoverContainerClassName = _a.popoverContainerClassName, _c = _a.positions, positions = _c === void 0 ? ['bottom'] : _c, _d = _a.align, align = _d === void 0 ? 'center' : _d, _e = _a.padding, padding = _e === void 0 ? 10 : _e, reposition = _a.reposition, onSelect = _a.onSelect, onClick = _a.onClick, customButton = _a.customButton, container = _a.container, label = _a.label, _f = _a.disabled, disabled = _f === void 0 ? false : _f, props = __rest(_a, ["closeOnSelect", "iconClassName", "iconContainerClassName", "popoverContainerClassName", "positions", "align", "padding", "reposition", "onSelect", "onClick", "customButton", "container", "label", "disabled"]);
    var _g = React.useState(false), open = _g[0], setOpen = _g[1];
    var toggleOpen = function () { return setOpen(!open); };
    var handleOnSelect = function (emoji) {
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(emoji);
        if (closeOnSelect) {
            setOpen(false);
        }
    };
    var handleOnClick = function () {
        if (!disabled) {
            onClick === null || onClick === void 0 ? void 0 : onClick();
            toggleOpen();
        }
    };
    return (React__default["default"].createElement(reactTinyPopover.Popover, { isOpen: open, onClickOutside: function () { return setOpen(false); }, padding: padding, content: React__default["default"].createElement(EmojiPicker, __assign({ onEmojiSelect: handleOnSelect }, props)), positions: positions, containerClassName: cx__default["default"](popoverContainerClassName, 'z-99'), parentElement: container, align: align, reposition: reposition },
        React__default["default"].createElement("span", { onClick: handleOnClick }, customButton !== null && customButton !== void 0 ? customButton : (React__default["default"].createElement("div", { className: cx__default["default"](iconContainerClassName, 'group flex flex-row gap-x-2 items-center cursor-pointer') },
            React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, { className: cx__default["default"](iconClassName, ['text-neutral-500 rounded-full cursor-pointer'], {
                    'group-hover:bg-yellow-500 group-hover:text-neutral-900': !disabled,
                }), icon: faLaugh }),
            label)))));
}

function ReplyInput(_a) {
    var inputId = _a.inputId, type = _a.type, inputRef = _a.inputRef, disableInput = _a.disableInput, value = _a.value, className = _a.className, placeholder = _a.placeholder, onInputChange = _a.onInputChange, onKeyDown = _a.onKeyDown, focused = _a.focused, _b = _a.textAreaDefaultHeight, textAreaDefaultHeight = _b === void 0 ? 50 : _b, _c = _a.textAreaMaxHeight, textAreaMaxHeight = _c === void 0 ? 80 : _c, maxLength = _a.maxLength;
    return type == exports.ReplyInputType.PlainInput ? (React__default["default"].createElement("input", { id: inputId, ref: inputRef, value: value, disabled: disableInput, className: cx__default["default"](className, 'h-10 text-sm text-border-neutral-700 px-2 w-full rounded border border-neutral-200 border-solid'), placeholder: disableInput ? '' : placeholder, onChange: function (event) {
            return onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(event.currentTarget.value);
        }, onKeyDown: onKeyDown, maxLength: maxLength })) : (React__default["default"].createElement(TextArea, { id: inputId, inputRef: inputRef, value: value, disabled: disableInput, className: cx__default["default"](className, 'transition-all'), maxHeight: textAreaMaxHeight, style: {
            height: focused ? textAreaMaxHeight : textAreaDefaultHeight,
        }, placeholder: disableInput ? '' : placeholder, onChange: function (event) {
            return onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(event.currentTarget.value);
        }, maxLength: maxLength }));
}

var replyByVideoIcon = 'https://cdn.bonjoro.com/assets/bonjoro-ui-components/reply-by-video.svg';
var ReplyByVideoIcon = styled__default["default"].div(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  mask: url(\"", "\");\n  mask-size: contain;\n  mask-repeat: no-repeat;\n  mask-position: center;\n"], ["\n  mask: url(\\\"", "\\\");\n  mask-size: contain;\n  mask-repeat: no-repeat;\n  mask-position: center;\n"])), replyByVideoIcon);
exports.ReplyInputType = void 0;
(function (ReplyInputType) {
    ReplyInputType["TextArea"] = "text_area";
    ReplyInputType["PlainInput"] = "plain_input";
})(exports.ReplyInputType || (exports.ReplyInputType = {}));
exports.ReplyPanelType = void 0;
(function (ReplyPanelType) {
    ReplyPanelType["Compact"] = "compact";
    ReplyPanelType["Column"] = "column";
})(exports.ReplyPanelType || (exports.ReplyPanelType = {}));
var columnIconClassName = 'rounded bg-neutral-200 px-2 hover:bg-turquoise-500 select-none font-bold py-[0.3rem] text-[16px]';
function ReplyPanel(_a) {
    var _b, _c;
    var id = _a.id, inputId = _a.inputId, value = _a.value, inputRef = _a.inputRef, placeholder = _a.placeholder, className = _a.className, containerClassName = _a.containerClassName, firstLayerClassName = _a.firstLayerClassName, secondLayerClassName = _a.secondLayerClassName, _d = _a.disableSend, disableSend = _d === void 0 ? false : _d, _e = _a.disableInput, disableInput = _e === void 0 ? false : _e, _f = _a.hideEmojiSelector, hideEmojiSelector = _f === void 0 ? false : _f, _g = _a.hideReplyByVideo, hideReplyByVideo = _g === void 0 ? false : _g, _h = _a.allowTextAreaResizeOnFocus, allowTextAreaResizeOnFocus = _h === void 0 ? true : _h, _j = _a.inputType, inputType = _j === void 0 ? exports.ReplyInputType.TextArea : _j, _k = _a.panelType, panelType = _k === void 0 ? exports.ReplyPanelType.Compact : _k, _l = _a.emojiLabel, emojiLabel = _l === void 0 ? 'Emoji' : _l, _m = _a.replyByVideoLabel, replyByVideoLabel = _m === void 0 ? 'Reply by video' : _m, _o = _a.sendLabel, sendLabel = _o === void 0 ? 'Send' : _o, inputClassName = _a.inputClassName, sendButtonClassName = _a.sendButtonClassName, emojiSelectorClassName = _a.emojiSelectorClassName, emojiSelectorIconClassName = _a.emojiSelectorIconClassName, replyByVideoClassName = _a.replyByVideoClassName, replyByVideoIconClassName = _a.replyByVideoIconClassName, emojiPopoverClassName = _a.emojiPopoverClassName, _p = _a.textAreaDefaultHeight, textAreaDefaultHeight = _p === void 0 ? 40 : _p, _q = _a.textAreaMaxHeight, textAreaMaxHeight = _q === void 0 ? 70 : _q, maxLength = _a.maxLength, _r = _a.popoverPositions, popoverPositions = _r === void 0 ? ['top', 'right'] : _r, _s = _a.popoverAlign, popoverAlign = _s === void 0 ? 'start' : _s, _t = _a.popoverPadding, popoverPadding = _t === void 0 ? 10 : _t, popoverReposition = _a.popoverReposition, onSendClick = _a.onSendClick, onEmojiSelect = _a.onEmojiSelect, onInputChange = _a.onInputChange, onFocus = _a.onFocus, onBlur = _a.onBlur, onReplyByVideoClick = _a.onReplyByVideoClick, onEnterKeyPress = _a.onEnterKeyPress, customInputComponent = _a.customInputComponent, _u = _a.container, container = _u === void 0 ? document : _u;
    var containerRef = React.useRef(null);
    var _v = React.useState(false), inputFocused = _v[0], setInputFocused = _v[1];
    var onClickHandler = React.useCallback(function () {
        if (!inputFocused) {
            onFocus === null || onFocus === void 0 ? void 0 : onFocus();
            setInputFocused(true);
        }
    }, [inputFocused]);
    /**
     *  Previous implementation of this component's focus/blur is by just using
     *  onFocus/onBlur from the main div but it cause more problems arised for the UI.
     *
     * The way we handle the Focus/Blur now for the Reply Panel is by detecting click
     * from the main div to set it as focused. This useEffect is to check if the current
     * focus is not within this element, hence, blurring out from this component
     */
    React.useEffect(function () {
        if (!containerRef.current)
            return;
        var handleClickOutside = function (e) {
            // Check if container div doesnt contain the clicked element from it's child elements.
            if (containerRef.current &&
                !containerRef.current.contains(e.target) &&
                inputFocused) {
                onBlur === null || onBlur === void 0 ? void 0 : onBlur();
                setInputFocused(false);
            }
        };
        // Bind and Unbind event listener
        container === null || container === void 0 ? void 0 : container.addEventListener('mousedown', handleClickOutside);
        return function () {
            container === null || container === void 0 ? void 0 : container.removeEventListener('mousedown', handleClickOutside);
        };
    }, [container, inputFocused]);
    var onSendClickHandler = function () {
        if (!value)
            return;
        onSendClick === null || onSendClick === void 0 ? void 0 : onSendClick(value);
    };
    var onKeyDownHandler = function (event) {
        if (!value)
            return;
        if (event.key === 'Enter' && value != '') {
            onEnterKeyPress === null || onEnterKeyPress === void 0 ? void 0 : onEnterKeyPress(value);
        }
    };
    var sendDisabled = value === '' || value === undefined || disableSend;
    var textAreaInputType = inputType === exports.ReplyInputType.TextArea;
    var compactPanelType = panelType == exports.ReplyPanelType.Compact;
    var columnPanelType = panelType == exports.ReplyPanelType.Column;
    var columnTextAreaFocused = columnPanelType &&
        inputFocused &&
        textAreaInputType &&
        allowTextAreaResizeOnFocus;
    var containerPadding = columnPanelType ? 60 : 20;
    var containerHeight = containerPadding +
        (columnTextAreaFocused ? textAreaMaxHeight : textAreaDefaultHeight);
    return (React__default["default"].createElement("div", { id: id, tabIndex: 0, className: cx__default["default"](className, [
            'w-full bg-neutral-50 flex flex-row transition-all',
            'justify-between items-center gap-x-2.5 px-4',
        ]), style: {
            height: containerHeight,
        }, onClick: onClickHandler, ref: containerRef },
        React__default["default"].createElement("div", { className: cx__default["default"](containerClassName, 'flex flex-1', {
                'flex-col gap-y-2': columnPanelType,
                'flex-row gap-x-2': compactPanelType,
            }) },
            React__default["default"].createElement("div", { className: cx__default["default"](firstLayerClassName, 'flex flex-row items-center gap-x-4') },
                !hideEmojiSelector && (React__default["default"].createElement(EmojiSelector, { closeOnSelect: true, onSelect: onEmojiSelect, positions: popoverPositions, align: popoverAlign, padding: popoverPadding, reposition: popoverReposition, container: containerRef === null || containerRef === void 0 ? void 0 : containerRef.current, disabled: disableInput, iconContainerClassName: cx__default["default"](emojiSelectorClassName, 'text-black', (_b = {},
                        _b[columnIconClassName] = columnPanelType,
                        _b)), popoverContainerClassName: emojiPopoverClassName, iconClassName: cx__default["default"](emojiSelectorIconClassName, 'text-black'), label: columnPanelType ? emojiLabel : '' })),
                !hideReplyByVideo && (React__default["default"].createElement("div", { tabIndex: 0, className: cx__default["default"](replyByVideoClassName, [
                        'flex flex-row gap-x-2 items-center cursor-pointer group',
                        'text-black',
                    ], (_c = {},
                        _c[columnIconClassName] = columnPanelType,
                        _c)), onClick: onReplyByVideoClick },
                    React__default["default"].createElement(ReplyByVideoIcon, { className: cx__default["default"](replyByVideoIconClassName, 'w-6 h-6 p-1 group-hover:bg-turquoise-700 bg-black cursor-pointer'), title: 'Reply by Video' }),
                    columnPanelType ? replyByVideoLabel : ''))),
            React__default["default"].createElement("div", { className: cx__default["default"](secondLayerClassName, 'flex flex-row gap-x-2 w-full') }, customInputComponent !== null && customInputComponent !== void 0 ? customInputComponent : (React__default["default"].createElement(ReplyInput, { inputId: inputId, type: inputType, inputRef: inputRef, disableInput: disableInput, value: value, placeholder: placeholder, onInputChange: onInputChange, textAreaDefaultHeight: textAreaDefaultHeight, textAreaMaxHeight: textAreaMaxHeight, className: inputClassName, onKeyDown: onKeyDownHandler, focused: columnTextAreaFocused, maxLength: maxLength })),
                React__default["default"].createElement(Button, { disabled: sendDisabled, className: cx__default["default"](sendButtonClassName, 'p-0 w-16 flex justify-center items-center flex flex-col'), onClick: onSendClickHandler },
                    React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, { className: 'w-4 h-5', icon: faPaperPlane }),
                    columnTextAreaFocused ? sendLabel : '')))));
}
var templateObject_1$1;

var bearLogo = 'https://cdn.bonjoro.com/assets/bonjoro-ui-components/bear-logo.png';
function WidgetPopup(_a) {
    var videoUrl = _a.videoUrl, videoRef = _a.videoRef, newTabHoverColor = _a.newTabHoverColor, showDefaultFullScreen = _a.showDefaultFullScreen, message = _a.message, _b = _a.initialFullScreen, initialFullScreen = _b === void 0 ? false : _b, _c = _a.hideCta, hideCta = _c === void 0 ? false : _c, ctaText = _a.ctaText, ctaColor = _a.ctaColor, ctaHref = _a.ctaHref, profileName = _a.profileName, profileImageUrl = _a.profileImageUrl, profileDescription = _a.profileDescription, className = _a.className, videoContainerClassName = _a.videoContainerClassName, videoClassName = _a.videoClassName, _d = _a.muted, muted = _d === void 0 ? false : _d, _e = _a.loop, loop = _e === void 0 ? false : _e, _f = _a.autoPlay, autoPlay = _f === void 0 ? true : _f, _g = _a.sendingReply, sendingReply = _g === void 0 ? false : _g, inputValue = _a.inputValue, onInputValueChange = _a.onInputValueChange, messageClassName = _a.messageClassName, profilePanelClassName = _a.profilePanelClassName, replyPanelClassName = _a.replyPanelClassName, scrollableContainerClassName = _a.scrollableContainerClassName, messageFooter = _a.messageFooter, _h = _a.hideProfilePanel, hideProfilePanel = _h === void 0 ? false : _h, _j = _a.hideBonjoroBadge, hideBonjoroBadge = _j === void 0 ? false : _j, _k = _a.hideReactionComponent, hideReactionComponent = _k === void 0 ? false : _k, placeholder = _a.placeholder, videoLeftHeaderComponent = _a.videoLeftHeaderComponent, videoFooterComponent = _a.videoFooterComponent, reactionComponent = _a.reactionComponent, _l = _a.hideEmojiSelector, hideEmojiSelector = _l === void 0 ? false : _l, _m = _a.hideReplyByVideo, hideReplyByVideo = _m === void 0 ? false : _m, customInputComponent = _a.customInputComponent, panelType = _a.panelType, inputType = _a.inputType, onReplyPanelFocus = _a.onReplyPanelFocus, onReplyPanelBlur = _a.onReplyPanelBlur, allowTextAreaResizeOnFocus = _a.allowTextAreaResizeOnFocus, onSendClick = _a.onSendClick, onCloseClick = _a.onCloseClick, onVideoLoaded = _a.onVideoLoaded, onReactClick = _a.onReactClick, onBonjoroBadgeClick = _a.onBonjoroBadgeClick, onCtaClick = _a.onCtaClick, onNewTabClick = _a.onNewTabClick, onFullScreenClick = _a.onFullScreenClick, onReplyByVideoClick = _a.onReplyByVideoClick, onEnterKeyPress = _a.onEnterKeyPress, container = _a.container, inputRef = _a.inputRef;
    var _o = React.useState(0), count = _o[0], setCount = _o[1];
    var _p = React.useState(initialFullScreen), fullScreen = _p[0], setFullScreen = _p[1];
    var _q = React.useState(false), videoLoaded = _q[0], setVideoLoaded = _q[1];
    var containerRef = React.useRef(null);
    var scrollableDivRef = React.useRef(null);
    var popupVideoRef = videoRef !== null && videoRef !== void 0 ? videoRef : React.useRef(null);
    var innerInputRef = inputRef !== null && inputRef !== void 0 ? inputRef : React.useRef(null);
    var _r = React.useState(''), popupInputValue = _r[0], setPopupInputValue = _r[1];
    var _s = React.useState(true), videoPlayerVisible = _s[0], setVideoPlayerVisible = _s[1];
    var input = inputValue !== null && inputValue !== void 0 ? inputValue : popupInputValue;
    var setInput = onInputValueChange !== null && onInputValueChange !== void 0 ? onInputValueChange : setPopupInputValue;
    var appendEmojiToInput = function (emoji) {
        if (innerInputRef.current) {
            var cursor = innerInputRef.current.selectionStart;
            setInput(innerInputRef.current.value.slice(0, cursor) +
                emoji +
                innerInputRef.current.value.slice(cursor));
            var newCursor_1 = cursor + emoji.length;
            setTimeout(function () { var _a; return (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.setSelectionRange(newCursor_1, newCursor_1); }, 10);
            innerInputRef.current.focus();
        }
    };
    var onReactClickHandler = function (args) {
        setCount(args.count);
        appendEmojiToInput(args.emoji);
        onReactClick === null || onReactClick === void 0 ? void 0 : onReactClick(args.emoji);
    };
    var onFullScreenClickHandler = function () {
        setFullScreen(!fullScreen);
        onFullScreenClick === null || onFullScreenClick === void 0 ? void 0 : onFullScreenClick();
    };
    var onCloseClickHandler = function () {
        var _a;
        (_a = popupVideoRef === null || popupVideoRef === void 0 ? void 0 : popupVideoRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
        onCloseClick === null || onCloseClick === void 0 ? void 0 : onCloseClick();
    };
    var onEmojiSelect = function (emoji) {
        appendEmojiToInput(emoji.native);
    };
    var onVideoLoadedHandler = function () {
        onVideoLoaded === null || onVideoLoaded === void 0 ? void 0 : onVideoLoaded();
        setVideoLoaded(true);
    };
    var scrollableDiv = useScrollDirection(scrollableDivRef);
    React.useEffect(function () {
        if (scrollableDiv.scrollDirection === undefined)
            return setVideoPlayerVisible(true);
        if (!popupVideoRef.current)
            return setVideoPlayerVisible(false);
        setVideoPlayerVisible(scrollableDiv.scrollPosition <
            popupVideoRef.current.getBoundingClientRect().height);
    }, [scrollableDiv, popupVideoRef.current]);
    var profilePanelProps = {
        name: profileName,
        imageUrl: profileImageUrl,
        description: profileDescription,
        loading: !videoLoaded,
        reactionComponent: reactionComponent !== null && reactionComponent !== void 0 ? reactionComponent : (!hideReactionComponent && (React__default["default"].createElement(ReactionButton, { initialCount: count, onClick: onReactClickHandler, hideCount: true }))),
    };
    var videoPlayerProps = {
        videoUrl: videoUrl,
        newTabHoverColor: newTabHoverColor,
        onNewTabClick: onNewTabClick,
        showDefaultFullScreen: showDefaultFullScreen,
        videoClassName: videoClassName,
        videoRef: popupVideoRef,
        muted: muted,
        loop: loop,
        autoPlay: autoPlay,
        onVideoLoaded: onVideoLoadedHandler,
        onCloseClick: onCloseClickHandler,
        onFullScreenClick: onFullScreenClickHandler,
        containerClassName: videoContainerClassName,
        hideLoader: false,
        leftHeaderComponent: videoLeftHeaderComponent !== null && videoLeftHeaderComponent !== void 0 ? videoLeftHeaderComponent : (!hideBonjoroBadge && (React__default["default"].createElement(SentWithBonjoroBadge, { iconUrl: bearLogo, className: 'bg-opacity-50 bg-black animate-fade-in', onClick: onBonjoroBadgeClick }))),
        footerComponent: videoFooterComponent !== null && videoFooterComponent !== void 0 ? videoFooterComponent : (videoPlayerVisible && !hideProfilePanel && (React__default["default"].createElement(ProfilePanel, __assign({}, profilePanelProps, { className: cx__default["default"](profilePanelClassName, 'relative') })))),
    };
    var videoMessageProps = {
        message: message,
        hideCta: hideCta,
        ctaText: ctaText,
        ctaColor: ctaColor,
        ctaHref: ctaHref,
        onCtaClick: onCtaClick,
        footer: messageFooter,
        loading: !videoLoaded,
        className: cx__default["default"](messageClassName, {
            'pt-14': !videoPlayerVisible && !hideProfilePanel,
        }),
    };
    var replyPanelProps = {
        inputRef: innerInputRef,
        onEmojiSelect: onEmojiSelect,
        onSendClick: onSendClick,
        onReplyByVideoClick: onReplyByVideoClick,
        onEnterKeyPress: onEnterKeyPress,
        hideEmojiSelector: hideEmojiSelector,
        hideReplyByVideo: hideReplyByVideo,
        customInputComponent: customInputComponent,
        panelType: panelType,
        inputType: inputType,
        onFocus: onReplyPanelFocus,
        onBlur: onReplyPanelBlur,
        allowTextAreaResizeOnFocus: allowTextAreaResizeOnFocus,
        container: container !== null && container !== void 0 ? container : containerRef === null || containerRef === void 0 ? void 0 : containerRef.current,
        disableInput: !videoLoaded || sendingReply,
        disableSend: sendingReply,
        className: replyPanelClassName,
        value: input,
        onInputChange: setInput,
        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "Send a reply to ".concat(profileName),
        inputClassName: 'py-2 px-3',
    };
    return (React__default["default"].createElement("div", { className: cx__default["default"](className, ['relative flex flex-col']), ref: containerRef },
        React__default["default"].createElement("div", { className: cx__default["default"](scrollableContainerClassName, [
                'flex-1 h-screen xs:h-full overflow-y-auto overflow-x-hidden',
            ]), ref: scrollableDivRef },
            React__default["default"].createElement(VideoPlayerContainer, __assign({}, videoPlayerProps)),
            !fullScreen && (React__default["default"].createElement(React__default["default"].Fragment, null,
                !videoPlayerVisible && !hideProfilePanel && (React__default["default"].createElement(ProfilePanel, __assign({}, profilePanelProps, { className: cx__default["default"](profilePanelClassName, 'absolute top-0 z-50 bg-opacity-80 animate-fade-in') }))),
                React__default["default"].createElement(VideoMessage, __assign({}, videoMessageProps))))),
        !fullScreen && React__default["default"].createElement(ReplyPanel, __assign({}, replyPanelProps))));
}

function Widget(_a) {
    var iconImageUrl = _a.iconImageUrl, themeColor = _a.themeColor, videoUrl = _a.videoUrl, message = _a.message, _b = _a.hidePreview, hidePreview = _b === void 0 ? false : _b, _c = _a.hidePing, hidePing = _c === void 0 ? false : _c, _d = _a.previewDelay, previewDelay = _d === void 0 ? 2000 : _d, showDefaultFullScreen = _a.showDefaultFullScreen, ctaText = _a.ctaText, ctaColor = _a.ctaColor, profileName = _a.profileName, profileImageUrl = _a.profileImageUrl, profileDescription = _a.profileDescription, _e = _a.yPlacement, yPlacement = _e === void 0 ? 'bottom' : _e, _f = _a.xPlacement, xPlacement = _f === void 0 ? 'left' : _f, onSendClick = _a.onSendClick, onBubbleClick = _a.onBubbleClick, onPreviewClick = _a.onPreviewClick, onPopupClose = _a.onPopupClose, onPreviewClose = _a.onPreviewClose, onReactClick = _a.onReactClick, onBonjoroBadgeClick = _a.onBonjoroBadgeClick, onCtaClick = _a.onCtaClick, onFullScreenClick = _a.onFullScreenClick, onNewTabClick = _a.onNewTabClick;
    var _g = React.useState(false), popupOpen = _g[0], setPopupOpen = _g[1];
    var _h = React.useState(false), previewOpen = _h[0], setPreviewOpen = _h[1];
    var popupParentRef = React.useRef(null);
    var videoRef = React.useRef(null);
    var openPreviewTimer;
    React.useEffect(function () {
        if (!hidePreview) {
            openPreviewTimer = setTimeout(function () {
                setPreviewOpen(true);
            }, previewDelay);
        }
    }, [hidePreview, previewDelay]);
    React.useEffect(function () {
        setPreviewOpen(false);
    }, [previewDelay, hidePreview]);
    var toggleVideoState = function () {
        var _a, _b;
        if (!popupOpen) {
            // eslint-disable-next-line
            (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.play();
        }
        else {
            (_b = videoRef.current) === null || _b === void 0 ? void 0 : _b.pause();
        }
    };
    var openPopup = function () {
        setPreviewOpen(false);
        setPopupOpen(!popupOpen);
        clearTimeout(openPreviewTimer);
        toggleVideoState();
    };
    var onBubbleClickHandler = function () {
        openPopup();
        onBubbleClick === null || onBubbleClick === void 0 ? void 0 : onBubbleClick();
    };
    var onPreviewClickHandler = function () {
        openPopup();
        onPreviewClick === null || onPreviewClick === void 0 ? void 0 : onPreviewClick();
    };
    var onPreviewCloseHandler = function () {
        onPreviewClose === null || onPreviewClose === void 0 ? void 0 : onPreviewClose();
        setPreviewOpen(false);
    };
    var onPopupCloseHandler = function () {
        onPopupClose === null || onPopupClose === void 0 ? void 0 : onPopupClose();
        setPopupOpen(false);
    };
    var bubbleProps = {
        iconImageUrl: iconImageUrl,
        borderColor: themeColor,
        showPing: !hidePing,
        onClick: onBubbleClickHandler,
        size: 54,
        className: cx__default["default"]({
            'hidden xs:inline-flex': popupOpen,
        }),
    };
    var previewProps = {
        videoUrl: videoUrl,
        message: message,
        muteIconBgColor: themeColor,
        className: cx__default["default"](['absolute animate-fade-in-down w-72 sm:w-96'], {
            'xs:top-1 top-20': yPlacement == 'top',
            'xs:bottom-1 bottom-20': yPlacement == 'bottom',
            'left-0 xs:left-20': xPlacement == 'left',
            'right-0 xs:right-20': xPlacement == 'right',
            hidden: !previewOpen,
        }),
        onClick: onPreviewClickHandler,
        onClose: onPreviewCloseHandler,
    };
    var popupProps = {
        videoUrl: videoUrl,
        showDefaultFullScreen: showDefaultFullScreen,
        message: message,
        ctaText: ctaText,
        ctaColor: ctaColor,
        profileName: profileName,
        profileImageUrl: profileImageUrl,
        profileDescription: profileDescription,
        onSendClick: onSendClick,
        onReactClick: onReactClick,
        onBonjoroBadgeClick: onBonjoroBadgeClick,
        onCtaClick: onCtaClick,
        onFullScreenClick: onFullScreenClick,
        onNewTabClick: onNewTabClick,
        videoRef: videoRef,
        newTabHoverColor: themeColor,
        onCloseClick: onPopupCloseHandler,
        autoPlay: false,
        videoClassName: 'min-w-32 w-full h-full xxs:h-72 xs:h-80',
        messageClassName: 'max-h-48',
        videoContainerClassName: 'w-full',
        className: 'bg-white',
        container: popupParentRef === null || popupParentRef === void 0 ? void 0 : popupParentRef.current,
    };
    return (React__default["default"].createElement("div", { className: cx__default["default"]('fixed', {
            'top-0 xs:top-4': popupOpen && yPlacement == 'top',
            'bottom-0 xs:bottom-4': popupOpen && yPlacement == 'bottom',
            'top-4': !popupOpen && yPlacement == 'top',
            'bottom-4': !popupOpen && yPlacement == 'bottom',
            'left-0 xs:left-4': popupOpen && xPlacement == 'left',
            'right-0 xs:right-4': popupOpen && xPlacement == 'right',
            'left-4': !popupOpen && xPlacement == 'left',
            'right-4': !popupOpen && xPlacement == 'right',
        }) },
        React__default["default"].createElement(WidgetPreview, __assign({}, previewProps)),
        React__default["default"].createElement("div", { className: cx__default["default"](['relative xs:absolute animate-fade-in-up xs:w-80 w-screen'], {
                'top-0 xs:top-1 ': yPlacement == 'top',
                'bottom-0 xs:bottom-1 ': yPlacement == 'bottom',
                'left-0 xs:left-20': xPlacement == 'left',
                'right-0 xs:right-20': xPlacement == 'right',
                hidden: !popupOpen,
            }), ref: popupParentRef },
            React__default["default"].createElement(WidgetPopup, __assign({}, popupProps))),
        React__default["default"].createElement(WidgetBubble, __assign({}, bubbleProps))));
}

var ReplyType;
(function (ReplyType) {
    ReplyType["Recipient"] = "recipient";
    ReplyType["Sender"] = "sender";
})(ReplyType || (ReplyType = {}));
var ReplyType$1 = ReplyType;

var ThreadBoxReply = styled__default["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  a {\n    color: ", ";\n    &:hover {\n      color: ", ";\n    }\n  }\n"], ["\n  a {\n    color: ", ";\n    &:hover {\n      color: ", ";\n    }\n  }\n"])), colors.turquoise[700], colors.turquoise[900]);
function defaultRenderReply(reply) {
    return (React__default["default"].createElement("span", { dangerouslySetInnerHTML: {
            __html: linkifyString__default["default"](reply.content, {
                target: {
                    url: '_blank',
                },
            }),
        } }));
}
function ThreadBox(_a) {
    var thread = _a.thread, className = _a.className, onVideoFullScreenClick = _a.onVideoFullScreenClick, _b = _a.renderTextReply, renderTextReply = _b === void 0 ? defaultRenderReply : _b;
    var name = thread.name, replyType = thread.replyType, replies = thread.replies;
    return (React__default["default"].createElement("div", { className: cx__default["default"](className, 'flex flex-col px-4 py-2', {
            'self-end': replyType == ReplyType$1.Recipient,
            'self-start': replyType == ReplyType$1.Sender,
        }) },
        React__default["default"].createElement("span", { className: cx__default["default"]('mb-2', {
                'text-purple-700': replyType == ReplyType$1.Recipient,
                'text-turquoise-700': replyType == ReplyType$1.Sender,
            }) }, name),
        replies.map(function (reply) {
            var media = reply.media, content = reply.content;
            return (React__default["default"].createElement("div", { key: reply.id },
                !media && content && (React__default["default"].createElement(ThreadBoxReply, { className: 'font-thin break-words' }, renderTextReply(reply))),
                media && (React__default["default"].createElement(VideoPlayerContainer, { key: media.id, containerClassName: 'min-w-32 min-h-[12rem] w-full h-full', videoClassName: 'rounded', videoUrl: media.videoUrl, hideNewTab: true, hideClose: true, videoThumbnail: media.thumbUrl, autoPlay: false, onFullScreenClick: onVideoFullScreenClick }))));
        })));
}
var templateObject_1;

function groupReplies(replies) {
    var comparator = function (a, b) {
        return a.name === b.name && !b.media && !a.media;
    };
    return consecutivePartition(replies, comparator).map(function (replies) {
        var _a = replies[0], name = _a.name, replyType = _a.replyType;
        return { name: name, replyType: replyType, replies: replies };
    });
}
function RepliesPanel(_a) {
    var replies = _a.replies, className = _a.className, onVideoFullScreenClick = _a.onVideoFullScreenClick, renderTextReply = _a.renderTextReply;
    var threads = React.useMemo(function () { return (replies ? groupReplies(replies) : []); }, [replies]);
    return (React__default["default"].createElement("div", { className: cx__default["default"](className, 'w-full flex flex-col px-3 py-1.5 gap-y-3') }, threads.map(function (thread, index) {
        return (React__default["default"].createElement(ThreadBox, { key: "".concat(thread.name, "-").concat(index), thread: thread, className: 'w-3/4 bg-neutral-50 rounded', onVideoFullScreenClick: onVideoFullScreenClick, renderTextReply: renderTextReply }));
    })));
}

function Accordion(_a) {
    var title = _a.title, children = _a.children, _b = _a.active, active = _b === void 0 ? false : _b, onClick = _a.onClick, rightComponent = _a.rightComponent, className = _a.className, arrowClassName = _a.arrowClassName, _c = _a.hideArrow, hideArrow = _c === void 0 ? false : _c;
    var _d = React.useState(active), activeState = _d[0], setActiveState = _d[1];
    var handleClick = function () {
        setActiveState(!activeState);
        onClick === null || onClick === void 0 ? void 0 : onClick(!activeState);
    };
    return (React__default["default"].createElement("div", { className: cx__default["default"](className, 'rounded shadow-around') },
        React__default["default"].createElement("div", { className: cx__default["default"]([
                'flex flex-col md:flex-row justify-between p-2 mt-2',
                'cursor-pointer select-none',
            ]), onClick: handleClick },
            React__default["default"].createElement("div", { className: 'flex justify-center md:justify-start' }, title),
            React__default["default"].createElement("div", { className: 'flex items-center justify-center' },
                rightComponent,
                !hideArrow && (React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, { icon: faChevronDown, className: cx__default["default"](arrowClassName, '!w-6 !h-6 transition-transform', {
                        'filter transform -rotate-180': activeState,
                    }) })))),
        React__default["default"].createElement("div", { className: cx__default["default"]('transition-all', {
                hidden: !activeState,
            }) }, children)));
}

var defaultHeight = '310px';
var defaultWidth = '100%';
function MegaMenu$1(_a) {
    var _b = _a.open, open = _b === void 0 ? false : _b, className = _a.className, _c = _a.height, height = _c === void 0 ? defaultHeight : _c, _d = _a.width, width = _d === void 0 ? defaultWidth : _d, children = _a.children;
    return (React__default["default"].createElement("div", { className: cx__default["default"]('duration-150 transition-height ease-out overflow-hidden', 'flex w-full bg-white left-0 w-full h-0 drop-shadow-md !absolute', 'z-[99999]', className), style: {
            height: open ? height : 0,
            width: width,
        } }, children));
}

function MegaMenuPanel(_a) {
    var className = _a.className, children = _a.children;
    return React__default["default"].createElement("div", { className: cx__default["default"](className, 'p-[30px]') }, children);
}

function PlasmicMegaMenu(_a) {
    var _b;
    var inactiveSlot = _a.inactiveSlot, activeSlot = _a.activeSlot, props = __rest(_a, ["inactiveSlot", "activeSlot"]);
    var _c = React.useState((_b = props.open) !== null && _b !== void 0 ? _b : false), open = _c[0], setOpen = _c[1];
    React.useEffect(function () {
        var _a;
        setOpen((_a = props.open) !== null && _a !== void 0 ? _a : false);
    }, [props.open]);
    function toggleOpen() {
        setOpen(function (open) { return !open; });
    }
    return (React__default["default"].createElement("div", null,
        React__default["default"].createElement("div", { onClick: toggleOpen },
            open && activeSlot,
            !open && inactiveSlot),
        React__default["default"].createElement(MegaMenu$1, __assign({}, props, { open: open }))));
}
var megaMenuPanel = createPlasmicComponent(MegaMenuPanel, {
    name: 'MegaMenuPanel',
    props: {
        className: 'string',
        children: 'slot',
    },
});
var megaMenu = createPlasmicComponent(PlasmicMegaMenu, {
    name: 'MegaMenu',
    props: {
        open: {
            type: 'boolean',
            defaultValue: false,
            editOnly: true,
        },
        height: {
            type: 'string',
            defaultValue: defaultHeight,
        },
        width: {
            type: 'string',
            defaultValue: defaultWidth,
        },
        activeSlot: {
            type: 'slot',
        },
        inactiveSlot: {
            type: 'slot',
        },
        children: {
            type: 'slot',
            defaultValue: [
                {
                    type: 'component',
                    name: 'MegaMenuPanel',
                },
                {
                    type: 'component',
                    name: 'MegaMenuPanel',
                },
                {
                    type: 'component',
                    name: 'MegaMenuPanel',
                },
            ],
        },
    },
});
function getPlasmicComponents$1() {
    return [megaMenu, megaMenuPanel];
}
var MegaMenu = {
    getPlasmicComponents: getPlasmicComponents$1,
};

function getPlasmicComponents() {
    return __spreadArray([], MegaMenu.getPlasmicComponents(), true);
}

exports.Accordion = Accordion;
exports.Button = Button;
exports.Checkbox = Checkbox;
exports.CookieDialog = CookieDialog;
exports.EmojiPicker = EmojiPicker;
exports.EmojiSelector = EmojiSelector;
exports.MegaMenu = MegaMenu$1;
exports.MegaMenuPanel = MegaMenuPanel;
exports.Panel = Panel;
exports.PanelContext = PanelContext;
exports.PanelGroup = PanelGroup;
exports.Ping = Ping;
exports.ProfilePanel = ProfilePanel;
exports.Questionnaire = Questionnaire;
exports.ReactionButton = ReactionButton;
exports.RepliesPanel = RepliesPanel;
exports.ReplyInput = ReplyInput;
exports.ReplyPanel = ReplyPanel;
exports.ReplyType = ReplyType$1;
exports.Select = Select;
exports.SentWithBonjoroBadge = SentWithBonjoroBadge;
exports.Tab = Tab;
exports.Tabs = Tabs;
exports.TextArea = TextArea;
exports.VideoMessage = VideoMessage;
exports.VideoPlayer = VideoPlayerContainer;
exports.Widget = Widget;
exports.WidgetBubble = WidgetBubble;
exports.WidgetPopup = WidgetPopup;
exports.WidgetPreview = WidgetPreview;
exports.getPlasmicComponents = getPlasmicComponents;
exports.isColorLight = isColorLight;
exports.selectComponents = components;
exports.theme = theme;
